// This file is generated by `gulp generate-api`
'use strict';

exports.__esModule = true;
exports.fetchApplicationConstraints = fetchApplicationConstraints;
exports.fetchApplicationConstraintsReset = fetchApplicationConstraintsReset;
exports.fetchApplicationCreditLimit = fetchApplicationCreditLimit;
exports.fetchApplicationCreditLimitReset = fetchApplicationCreditLimitReset;
exports.fetchApplicationFirstLoanOffer = fetchApplicationFirstLoanOffer;
exports.fetchApplicationFirstLoanOfferReset = fetchApplicationFirstLoanOfferReset;
exports.fetchApplicationFirstLoanOfferExtraServiceFee = fetchApplicationFirstLoanOfferExtraServiceFee;
exports.fetchApplicationFirstLoanOfferExtraServiceFeeReset = fetchApplicationFirstLoanOfferExtraServiceFeeReset;
exports.fetchApplicationLoginByAccessid = fetchApplicationLoginByAccessid;
exports.fetchApplicationLoginByAccessidReset = fetchApplicationLoginByAccessidReset;
exports.fetchApplicationNextLoanOffer = fetchApplicationNextLoanOffer;
exports.fetchApplicationNextLoanOfferReset = fetchApplicationNextLoanOfferReset;
exports.fetchApplicationNextLoanOfferExtraServiceFee = fetchApplicationNextLoanOfferExtraServiceFee;
exports.fetchApplicationNextLoanOfferExtraServiceFeeReset = fetchApplicationNextLoanOfferExtraServiceFeeReset;
exports.fetchClient = fetchClient;
exports.fetchClientReset = fetchClientReset;
exports.fetchClientAgreementsPreliminary = fetchClientAgreementsPreliminary;
exports.fetchClientAgreementsPreliminaryReset = fetchClientAgreementsPreliminaryReset;
exports.fetchClientApplication = fetchClientApplication;
exports.fetchClientApplicationReset = fetchClientApplicationReset;
exports.fetchClientApplicationConstraints = fetchClientApplicationConstraints;
exports.fetchClientApplicationConstraintsReset = fetchClientApplicationConstraintsReset;
exports.fetchClientApplicationOffer = fetchClientApplicationOffer;
exports.fetchClientApplicationOfferReset = fetchClientApplicationOfferReset;
exports.fetchClientApplicationOfferExtraServiceFee = fetchClientApplicationOfferExtraServiceFee;
exports.fetchClientApplicationOfferExtraServiceFeeReset = fetchClientApplicationOfferExtraServiceFeeReset;
exports.fetchClientApplicationProposals = fetchClientApplicationProposals;
exports.fetchClientApplicationProposalsReset = fetchClientApplicationProposalsReset;
exports.fetchClientBankAccountNumber = fetchClientBankAccountNumber;
exports.fetchClientBankAccountNumberReset = fetchClientBankAccountNumberReset;
exports.fetchClientBanks = fetchClientBanks;
exports.fetchClientBanksReset = fetchClientBanksReset;
exports.fetchClientCheck = fetchClientCheck;
exports.fetchClientCheckReset = fetchClientCheckReset;
exports.fetchClientConsents = fetchClientConsents;
exports.fetchClientConsentsReset = fetchClientConsentsReset;
exports.fetchClientDiscounts = fetchClientDiscounts;
exports.fetchClientDiscountsReset = fetchClientDiscountsReset;
exports.fetchClientDiscountsAvailable = fetchClientDiscountsAvailable;
exports.fetchClientDiscountsAvailableReset = fetchClientDiscountsAvailableReset;
exports.fetchClientEmail = fetchClientEmail;
exports.fetchClientEmailReset = fetchClientEmailReset;
exports.fetchClientEmailRateLimitStatus = fetchClientEmailRateLimitStatus;
exports.fetchClientEmailRateLimitStatusReset = fetchClientEmailRateLimitStatusReset;
exports.fetchClientEmployer = fetchClientEmployer;
exports.fetchClientEmployerReset = fetchClientEmployerReset;
exports.fetchClientGeneralTerms = fetchClientGeneralTerms;
exports.fetchClientGeneralTermsReset = fetchClientGeneralTermsReset;
exports.fetchClientIdentityDocumentPhotoById = fetchClientIdentityDocumentPhotoById;
exports.fetchClientIdentityDocumentPhotoByIdReset = fetchClientIdentityDocumentPhotoByIdReset;
exports.fetchClientIdentityDocumentPhotos = fetchClientIdentityDocumentPhotos;
exports.fetchClientIdentityDocumentPhotosReset = fetchClientIdentityDocumentPhotosReset;
exports.fetchClientLegalTerms = fetchClientLegalTerms;
exports.fetchClientLegalTermsReset = fetchClientLegalTermsReset;
exports.fetchClientLoans = fetchClientLoans;
exports.fetchClientLoansReset = fetchClientLoansReset;
exports.fetchClientLoansByLoanid = fetchClientLoansByLoanid;
exports.fetchClientLoansByLoanidReset = fetchClientLoansByLoanidReset;
exports.fetchClientLoansDebtPaymentScheduleByLoanid = fetchClientLoansDebtPaymentScheduleByLoanid;
exports.fetchClientLoansDebtPaymentScheduleByLoanidReset = fetchClientLoansDebtPaymentScheduleByLoanidReset;
exports.fetchClientMissingMandatoryFields = fetchClientMissingMandatoryFields;
exports.fetchClientMissingMandatoryFieldsReset = fetchClientMissingMandatoryFieldsReset;
exports.fetchClientPasswordRecoveryPhoneByPhonenumber = fetchClientPasswordRecoveryPhoneByPhonenumber;
exports.fetchClientPasswordRecoveryPhoneByPhonenumberReset = fetchClientPasswordRecoveryPhoneByPhonenumberReset;
exports.fetchClientPhone = fetchClientPhone;
exports.fetchClientPhoneReset = fetchClientPhoneReset;
exports.fetchClientPhoneRateLimitStatus = fetchClientPhoneRateLimitStatus;
exports.fetchClientPhoneRateLimitStatusReset = fetchClientPhoneRateLimitStatusReset;
exports.fetchClientSettings = fetchClientSettings;
exports.fetchClientSettingsReset = fetchClientSettingsReset;
exports.fetchDictionaryCountries = fetchDictionaryCountries;
exports.fetchDictionaryCountriesReset = fetchDictionaryCountriesReset;
exports.fetchEmploymentProfessions = fetchEmploymentProfessions;
exports.fetchEmploymentProfessionsReset = fetchEmploymentProfessionsReset;
exports.fetchFirstLoanLegalTerms = fetchFirstLoanLegalTerms;
exports.fetchFirstLoanLegalTermsReset = fetchFirstLoanLegalTermsReset;
exports.fetchGeneralTerms = fetchGeneralTerms;
exports.fetchGeneralTermsReset = fetchGeneralTermsReset;
exports.fetchNextLoanLegalTerms = fetchNextLoanLegalTerms;
exports.fetchNextLoanLegalTermsReset = fetchNextLoanLegalTermsReset;
exports.fetchRegistration = fetchRegistration;
exports.fetchRegistrationReset = fetchRegistrationReset;
exports.sendClientApplication = sendClientApplication;
exports.sendClientApplicationReset = sendClientApplicationReset;
exports.sendClientCookies = sendClientCookies;
exports.sendClientCookiesReset = sendClientCookiesReset;
exports.sendClientEmail = sendClientEmail;
exports.sendClientEmailReset = sendClientEmailReset;
exports.sendClientIdentityDocumentUploadPhoto = sendClientIdentityDocumentUploadPhoto;
exports.sendClientIdentityDocumentUploadPhotoReset = sendClientIdentityDocumentUploadPhotoReset;
exports.sendClientPasswordRecoveryValidateCode = sendClientPasswordRecoveryValidateCode;
exports.sendClientPasswordRecoveryValidateCodeReset = sendClientPasswordRecoveryValidateCodeReset;
exports.sendClientPhone = sendClientPhone;
exports.sendClientPhoneReset = sendClientPhoneReset;
exports.sendClientTemporaryPassword = sendClientTemporaryPassword;
exports.sendClientTemporaryPasswordReset = sendClientTemporaryPasswordReset;
exports.sendRegistration = sendRegistration;
exports.sendRegistrationReset = sendRegistrationReset;
exports.sendTokenApplication = sendTokenApplication;
exports.sendTokenApplicationReset = sendTokenApplicationReset;
exports.sendTokenBasic = sendTokenBasic;
exports.sendTokenBasicReset = sendTokenBasicReset;
exports.patchClientApplication = patchClientApplication;
exports.patchClientApplicationReset = patchClientApplicationReset;
exports.patchClientBankAccountNumber = patchClientBankAccountNumber;
exports.patchClientBankAccountNumberReset = patchClientBankAccountNumberReset;
exports.patchClientEmailConfirmation = patchClientEmailConfirmation;
exports.patchClientEmailConfirmationReset = patchClientEmailConfirmationReset;
exports.patchClientEmployer = patchClientEmployer;
exports.patchClientEmployerReset = patchClientEmployerReset;
exports.patchClientMissingMandatoryFields = patchClientMissingMandatoryFields;
exports.patchClientMissingMandatoryFieldsReset = patchClientMissingMandatoryFieldsReset;
exports.patchClientPassword = patchClientPassword;
exports.patchClientPasswordReset = patchClientPasswordReset;
exports.patchClientPhone = patchClientPhone;
exports.patchClientPhoneReset = patchClientPhoneReset;
exports.patchClientPhoneConfirmation = patchClientPhoneConfirmation;
exports.patchClientPhoneConfirmationReset = patchClientPhoneConfirmationReset;
exports.patchClientProfile = patchClientProfile;
exports.patchClientProfileReset = patchClientProfileReset;
exports.patchClientSettings = patchClientSettings;
exports.patchClientSettingsReset = patchClientSettingsReset;
var FETCH_APPLICATION_CONSTRAINTS_SUCCESS = 'FETCH_APPLICATION_CONSTRAINTS_SUCCESS';
exports.FETCH_APPLICATION_CONSTRAINTS_SUCCESS = FETCH_APPLICATION_CONSTRAINTS_SUCCESS;
var FETCH_APPLICATION_CONSTRAINTS_START = 'FETCH_APPLICATION_CONSTRAINTS_START';
exports.FETCH_APPLICATION_CONSTRAINTS_START = FETCH_APPLICATION_CONSTRAINTS_START;
var FETCH_APPLICATION_CONSTRAINTS_ERROR = 'FETCH_APPLICATION_CONSTRAINTS_ERROR';
exports.FETCH_APPLICATION_CONSTRAINTS_ERROR = FETCH_APPLICATION_CONSTRAINTS_ERROR;
var FETCH_APPLICATION_CONSTRAINTS_RESET = 'FETCH_APPLICATION_CONSTRAINTS_RESET';
exports.FETCH_APPLICATION_CONSTRAINTS_RESET = FETCH_APPLICATION_CONSTRAINTS_RESET;
var FETCH_APPLICATION_CREDIT_LIMIT_SUCCESS = 'FETCH_APPLICATION_CREDIT_LIMIT_SUCCESS';
exports.FETCH_APPLICATION_CREDIT_LIMIT_SUCCESS = FETCH_APPLICATION_CREDIT_LIMIT_SUCCESS;
var FETCH_APPLICATION_CREDIT_LIMIT_START = 'FETCH_APPLICATION_CREDIT_LIMIT_START';
exports.FETCH_APPLICATION_CREDIT_LIMIT_START = FETCH_APPLICATION_CREDIT_LIMIT_START;
var FETCH_APPLICATION_CREDIT_LIMIT_ERROR = 'FETCH_APPLICATION_CREDIT_LIMIT_ERROR';
exports.FETCH_APPLICATION_CREDIT_LIMIT_ERROR = FETCH_APPLICATION_CREDIT_LIMIT_ERROR;
var FETCH_APPLICATION_CREDIT_LIMIT_RESET = 'FETCH_APPLICATION_CREDIT_LIMIT_RESET';
exports.FETCH_APPLICATION_CREDIT_LIMIT_RESET = FETCH_APPLICATION_CREDIT_LIMIT_RESET;
var FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_SUCCESS = 'FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_SUCCESS';
exports.FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_SUCCESS = FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_SUCCESS;
var FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_START = 'FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_START';
exports.FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_START = FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_START;
var FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_ERROR = 'FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_ERROR';
exports.FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_ERROR = FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_ERROR;
var FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_RESET = 'FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_RESET';
exports.FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_RESET = FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_RESET;
var FETCH_APPLICATION_FIRST_LOAN_OFFER_SUCCESS = 'FETCH_APPLICATION_FIRST_LOAN_OFFER_SUCCESS';
exports.FETCH_APPLICATION_FIRST_LOAN_OFFER_SUCCESS = FETCH_APPLICATION_FIRST_LOAN_OFFER_SUCCESS;
var FETCH_APPLICATION_FIRST_LOAN_OFFER_START = 'FETCH_APPLICATION_FIRST_LOAN_OFFER_START';
exports.FETCH_APPLICATION_FIRST_LOAN_OFFER_START = FETCH_APPLICATION_FIRST_LOAN_OFFER_START;
var FETCH_APPLICATION_FIRST_LOAN_OFFER_ERROR = 'FETCH_APPLICATION_FIRST_LOAN_OFFER_ERROR';
exports.FETCH_APPLICATION_FIRST_LOAN_OFFER_ERROR = FETCH_APPLICATION_FIRST_LOAN_OFFER_ERROR;
var FETCH_APPLICATION_FIRST_LOAN_OFFER_RESET = 'FETCH_APPLICATION_FIRST_LOAN_OFFER_RESET';
exports.FETCH_APPLICATION_FIRST_LOAN_OFFER_RESET = FETCH_APPLICATION_FIRST_LOAN_OFFER_RESET;
var FETCH_APPLICATION_LOGIN_BY_ACCESSID_SUCCESS = 'FETCH_APPLICATION_LOGIN_BY_ACCESSID_SUCCESS';
exports.FETCH_APPLICATION_LOGIN_BY_ACCESSID_SUCCESS = FETCH_APPLICATION_LOGIN_BY_ACCESSID_SUCCESS;
var FETCH_APPLICATION_LOGIN_BY_ACCESSID_START = 'FETCH_APPLICATION_LOGIN_BY_ACCESSID_START';
exports.FETCH_APPLICATION_LOGIN_BY_ACCESSID_START = FETCH_APPLICATION_LOGIN_BY_ACCESSID_START;
var FETCH_APPLICATION_LOGIN_BY_ACCESSID_ERROR = 'FETCH_APPLICATION_LOGIN_BY_ACCESSID_ERROR';
exports.FETCH_APPLICATION_LOGIN_BY_ACCESSID_ERROR = FETCH_APPLICATION_LOGIN_BY_ACCESSID_ERROR;
var FETCH_APPLICATION_LOGIN_BY_ACCESSID_RESET = 'FETCH_APPLICATION_LOGIN_BY_ACCESSID_RESET';
exports.FETCH_APPLICATION_LOGIN_BY_ACCESSID_RESET = FETCH_APPLICATION_LOGIN_BY_ACCESSID_RESET;
var FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_SUCCESS = 'FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_SUCCESS';
exports.FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_SUCCESS = FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_SUCCESS;
var FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_START = 'FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_START';
exports.FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_START = FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_START;
var FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_ERROR = 'FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_ERROR';
exports.FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_ERROR = FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_ERROR;
var FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_RESET = 'FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_RESET';
exports.FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_RESET = FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_RESET;
var FETCH_APPLICATION_NEXT_LOAN_OFFER_SUCCESS = 'FETCH_APPLICATION_NEXT_LOAN_OFFER_SUCCESS';
exports.FETCH_APPLICATION_NEXT_LOAN_OFFER_SUCCESS = FETCH_APPLICATION_NEXT_LOAN_OFFER_SUCCESS;
var FETCH_APPLICATION_NEXT_LOAN_OFFER_START = 'FETCH_APPLICATION_NEXT_LOAN_OFFER_START';
exports.FETCH_APPLICATION_NEXT_LOAN_OFFER_START = FETCH_APPLICATION_NEXT_LOAN_OFFER_START;
var FETCH_APPLICATION_NEXT_LOAN_OFFER_ERROR = 'FETCH_APPLICATION_NEXT_LOAN_OFFER_ERROR';
exports.FETCH_APPLICATION_NEXT_LOAN_OFFER_ERROR = FETCH_APPLICATION_NEXT_LOAN_OFFER_ERROR;
var FETCH_APPLICATION_NEXT_LOAN_OFFER_RESET = 'FETCH_APPLICATION_NEXT_LOAN_OFFER_RESET';
exports.FETCH_APPLICATION_NEXT_LOAN_OFFER_RESET = FETCH_APPLICATION_NEXT_LOAN_OFFER_RESET;
var FETCH_CLIENT_AGREEMENTS_PRELIMINARY_SUCCESS = 'FETCH_CLIENT_AGREEMENTS_PRELIMINARY_SUCCESS';
exports.FETCH_CLIENT_AGREEMENTS_PRELIMINARY_SUCCESS = FETCH_CLIENT_AGREEMENTS_PRELIMINARY_SUCCESS;
var FETCH_CLIENT_AGREEMENTS_PRELIMINARY_START = 'FETCH_CLIENT_AGREEMENTS_PRELIMINARY_START';
exports.FETCH_CLIENT_AGREEMENTS_PRELIMINARY_START = FETCH_CLIENT_AGREEMENTS_PRELIMINARY_START;
var FETCH_CLIENT_AGREEMENTS_PRELIMINARY_ERROR = 'FETCH_CLIENT_AGREEMENTS_PRELIMINARY_ERROR';
exports.FETCH_CLIENT_AGREEMENTS_PRELIMINARY_ERROR = FETCH_CLIENT_AGREEMENTS_PRELIMINARY_ERROR;
var FETCH_CLIENT_AGREEMENTS_PRELIMINARY_RESET = 'FETCH_CLIENT_AGREEMENTS_PRELIMINARY_RESET';
exports.FETCH_CLIENT_AGREEMENTS_PRELIMINARY_RESET = FETCH_CLIENT_AGREEMENTS_PRELIMINARY_RESET;
var FETCH_CLIENT_APPLICATION_CONSTRAINTS_SUCCESS = 'FETCH_CLIENT_APPLICATION_CONSTRAINTS_SUCCESS';
exports.FETCH_CLIENT_APPLICATION_CONSTRAINTS_SUCCESS = FETCH_CLIENT_APPLICATION_CONSTRAINTS_SUCCESS;
var FETCH_CLIENT_APPLICATION_CONSTRAINTS_START = 'FETCH_CLIENT_APPLICATION_CONSTRAINTS_START';
exports.FETCH_CLIENT_APPLICATION_CONSTRAINTS_START = FETCH_CLIENT_APPLICATION_CONSTRAINTS_START;
var FETCH_CLIENT_APPLICATION_CONSTRAINTS_ERROR = 'FETCH_CLIENT_APPLICATION_CONSTRAINTS_ERROR';
exports.FETCH_CLIENT_APPLICATION_CONSTRAINTS_ERROR = FETCH_CLIENT_APPLICATION_CONSTRAINTS_ERROR;
var FETCH_CLIENT_APPLICATION_CONSTRAINTS_RESET = 'FETCH_CLIENT_APPLICATION_CONSTRAINTS_RESET';
exports.FETCH_CLIENT_APPLICATION_CONSTRAINTS_RESET = FETCH_CLIENT_APPLICATION_CONSTRAINTS_RESET;
var FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_SUCCESS = 'FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_SUCCESS';
exports.FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_SUCCESS = FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_SUCCESS;
var FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_START = 'FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_START';
exports.FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_START = FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_START;
var FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_ERROR = 'FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_ERROR';
exports.FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_ERROR = FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_ERROR;
var FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_RESET = 'FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_RESET';
exports.FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_RESET = FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_RESET;
var FETCH_CLIENT_APPLICATION_OFFER_SUCCESS = 'FETCH_CLIENT_APPLICATION_OFFER_SUCCESS';
exports.FETCH_CLIENT_APPLICATION_OFFER_SUCCESS = FETCH_CLIENT_APPLICATION_OFFER_SUCCESS;
var FETCH_CLIENT_APPLICATION_OFFER_START = 'FETCH_CLIENT_APPLICATION_OFFER_START';
exports.FETCH_CLIENT_APPLICATION_OFFER_START = FETCH_CLIENT_APPLICATION_OFFER_START;
var FETCH_CLIENT_APPLICATION_OFFER_ERROR = 'FETCH_CLIENT_APPLICATION_OFFER_ERROR';
exports.FETCH_CLIENT_APPLICATION_OFFER_ERROR = FETCH_CLIENT_APPLICATION_OFFER_ERROR;
var FETCH_CLIENT_APPLICATION_OFFER_RESET = 'FETCH_CLIENT_APPLICATION_OFFER_RESET';
exports.FETCH_CLIENT_APPLICATION_OFFER_RESET = FETCH_CLIENT_APPLICATION_OFFER_RESET;
var FETCH_CLIENT_APPLICATION_PROPOSALS_SUCCESS = 'FETCH_CLIENT_APPLICATION_PROPOSALS_SUCCESS';
exports.FETCH_CLIENT_APPLICATION_PROPOSALS_SUCCESS = FETCH_CLIENT_APPLICATION_PROPOSALS_SUCCESS;
var FETCH_CLIENT_APPLICATION_PROPOSALS_START = 'FETCH_CLIENT_APPLICATION_PROPOSALS_START';
exports.FETCH_CLIENT_APPLICATION_PROPOSALS_START = FETCH_CLIENT_APPLICATION_PROPOSALS_START;
var FETCH_CLIENT_APPLICATION_PROPOSALS_ERROR = 'FETCH_CLIENT_APPLICATION_PROPOSALS_ERROR';
exports.FETCH_CLIENT_APPLICATION_PROPOSALS_ERROR = FETCH_CLIENT_APPLICATION_PROPOSALS_ERROR;
var FETCH_CLIENT_APPLICATION_PROPOSALS_RESET = 'FETCH_CLIENT_APPLICATION_PROPOSALS_RESET';
exports.FETCH_CLIENT_APPLICATION_PROPOSALS_RESET = FETCH_CLIENT_APPLICATION_PROPOSALS_RESET;
var FETCH_CLIENT_APPLICATION_SUCCESS = 'FETCH_CLIENT_APPLICATION_SUCCESS';
exports.FETCH_CLIENT_APPLICATION_SUCCESS = FETCH_CLIENT_APPLICATION_SUCCESS;
var FETCH_CLIENT_APPLICATION_START = 'FETCH_CLIENT_APPLICATION_START';
exports.FETCH_CLIENT_APPLICATION_START = FETCH_CLIENT_APPLICATION_START;
var FETCH_CLIENT_APPLICATION_ERROR = 'FETCH_CLIENT_APPLICATION_ERROR';
exports.FETCH_CLIENT_APPLICATION_ERROR = FETCH_CLIENT_APPLICATION_ERROR;
var FETCH_CLIENT_APPLICATION_RESET = 'FETCH_CLIENT_APPLICATION_RESET';
exports.FETCH_CLIENT_APPLICATION_RESET = FETCH_CLIENT_APPLICATION_RESET;
var FETCH_CLIENT_BANKS_SUCCESS = 'FETCH_CLIENT_BANKS_SUCCESS';
exports.FETCH_CLIENT_BANKS_SUCCESS = FETCH_CLIENT_BANKS_SUCCESS;
var FETCH_CLIENT_BANKS_START = 'FETCH_CLIENT_BANKS_START';
exports.FETCH_CLIENT_BANKS_START = FETCH_CLIENT_BANKS_START;
var FETCH_CLIENT_BANKS_ERROR = 'FETCH_CLIENT_BANKS_ERROR';
exports.FETCH_CLIENT_BANKS_ERROR = FETCH_CLIENT_BANKS_ERROR;
var FETCH_CLIENT_BANKS_RESET = 'FETCH_CLIENT_BANKS_RESET';
exports.FETCH_CLIENT_BANKS_RESET = FETCH_CLIENT_BANKS_RESET;
var FETCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS = 'FETCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS';
exports.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS = FETCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS;
var FETCH_CLIENT_BANK_ACCOUNT_NUMBER_START = 'FETCH_CLIENT_BANK_ACCOUNT_NUMBER_START';
exports.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_START = FETCH_CLIENT_BANK_ACCOUNT_NUMBER_START;
var FETCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR = 'FETCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR';
exports.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR = FETCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR;
var FETCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET = 'FETCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET';
exports.FETCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET = FETCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET;
var FETCH_CLIENT_CHECK_SUCCESS = 'FETCH_CLIENT_CHECK_SUCCESS';
exports.FETCH_CLIENT_CHECK_SUCCESS = FETCH_CLIENT_CHECK_SUCCESS;
var FETCH_CLIENT_CHECK_START = 'FETCH_CLIENT_CHECK_START';
exports.FETCH_CLIENT_CHECK_START = FETCH_CLIENT_CHECK_START;
var FETCH_CLIENT_CHECK_ERROR = 'FETCH_CLIENT_CHECK_ERROR';
exports.FETCH_CLIENT_CHECK_ERROR = FETCH_CLIENT_CHECK_ERROR;
var FETCH_CLIENT_CHECK_RESET = 'FETCH_CLIENT_CHECK_RESET';
exports.FETCH_CLIENT_CHECK_RESET = FETCH_CLIENT_CHECK_RESET;
var FETCH_CLIENT_CONSENTS_SUCCESS = 'FETCH_CLIENT_CONSENTS_SUCCESS';
exports.FETCH_CLIENT_CONSENTS_SUCCESS = FETCH_CLIENT_CONSENTS_SUCCESS;
var FETCH_CLIENT_CONSENTS_START = 'FETCH_CLIENT_CONSENTS_START';
exports.FETCH_CLIENT_CONSENTS_START = FETCH_CLIENT_CONSENTS_START;
var FETCH_CLIENT_CONSENTS_ERROR = 'FETCH_CLIENT_CONSENTS_ERROR';
exports.FETCH_CLIENT_CONSENTS_ERROR = FETCH_CLIENT_CONSENTS_ERROR;
var FETCH_CLIENT_CONSENTS_RESET = 'FETCH_CLIENT_CONSENTS_RESET';
exports.FETCH_CLIENT_CONSENTS_RESET = FETCH_CLIENT_CONSENTS_RESET;
var FETCH_CLIENT_DISCOUNTS_AVAILABLE_SUCCESS = 'FETCH_CLIENT_DISCOUNTS_AVAILABLE_SUCCESS';
exports.FETCH_CLIENT_DISCOUNTS_AVAILABLE_SUCCESS = FETCH_CLIENT_DISCOUNTS_AVAILABLE_SUCCESS;
var FETCH_CLIENT_DISCOUNTS_AVAILABLE_START = 'FETCH_CLIENT_DISCOUNTS_AVAILABLE_START';
exports.FETCH_CLIENT_DISCOUNTS_AVAILABLE_START = FETCH_CLIENT_DISCOUNTS_AVAILABLE_START;
var FETCH_CLIENT_DISCOUNTS_AVAILABLE_ERROR = 'FETCH_CLIENT_DISCOUNTS_AVAILABLE_ERROR';
exports.FETCH_CLIENT_DISCOUNTS_AVAILABLE_ERROR = FETCH_CLIENT_DISCOUNTS_AVAILABLE_ERROR;
var FETCH_CLIENT_DISCOUNTS_AVAILABLE_RESET = 'FETCH_CLIENT_DISCOUNTS_AVAILABLE_RESET';
exports.FETCH_CLIENT_DISCOUNTS_AVAILABLE_RESET = FETCH_CLIENT_DISCOUNTS_AVAILABLE_RESET;
var FETCH_CLIENT_DISCOUNTS_SUCCESS = 'FETCH_CLIENT_DISCOUNTS_SUCCESS';
exports.FETCH_CLIENT_DISCOUNTS_SUCCESS = FETCH_CLIENT_DISCOUNTS_SUCCESS;
var FETCH_CLIENT_DISCOUNTS_START = 'FETCH_CLIENT_DISCOUNTS_START';
exports.FETCH_CLIENT_DISCOUNTS_START = FETCH_CLIENT_DISCOUNTS_START;
var FETCH_CLIENT_DISCOUNTS_ERROR = 'FETCH_CLIENT_DISCOUNTS_ERROR';
exports.FETCH_CLIENT_DISCOUNTS_ERROR = FETCH_CLIENT_DISCOUNTS_ERROR;
var FETCH_CLIENT_DISCOUNTS_RESET = 'FETCH_CLIENT_DISCOUNTS_RESET';
exports.FETCH_CLIENT_DISCOUNTS_RESET = FETCH_CLIENT_DISCOUNTS_RESET;
var FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_SUCCESS = 'FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_SUCCESS';
exports.FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_SUCCESS = FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_SUCCESS;
var FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_START = 'FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_START';
exports.FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_START = FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_START;
var FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_ERROR = 'FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_ERROR';
exports.FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_ERROR = FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_ERROR;
var FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_RESET = 'FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_RESET';
exports.FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_RESET = FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_RESET;
var FETCH_CLIENT_EMAIL_SUCCESS = 'FETCH_CLIENT_EMAIL_SUCCESS';
exports.FETCH_CLIENT_EMAIL_SUCCESS = FETCH_CLIENT_EMAIL_SUCCESS;
var FETCH_CLIENT_EMAIL_START = 'FETCH_CLIENT_EMAIL_START';
exports.FETCH_CLIENT_EMAIL_START = FETCH_CLIENT_EMAIL_START;
var FETCH_CLIENT_EMAIL_ERROR = 'FETCH_CLIENT_EMAIL_ERROR';
exports.FETCH_CLIENT_EMAIL_ERROR = FETCH_CLIENT_EMAIL_ERROR;
var FETCH_CLIENT_EMAIL_RESET = 'FETCH_CLIENT_EMAIL_RESET';
exports.FETCH_CLIENT_EMAIL_RESET = FETCH_CLIENT_EMAIL_RESET;
var FETCH_CLIENT_EMPLOYER_SUCCESS = 'FETCH_CLIENT_EMPLOYER_SUCCESS';
exports.FETCH_CLIENT_EMPLOYER_SUCCESS = FETCH_CLIENT_EMPLOYER_SUCCESS;
var FETCH_CLIENT_EMPLOYER_START = 'FETCH_CLIENT_EMPLOYER_START';
exports.FETCH_CLIENT_EMPLOYER_START = FETCH_CLIENT_EMPLOYER_START;
var FETCH_CLIENT_EMPLOYER_ERROR = 'FETCH_CLIENT_EMPLOYER_ERROR';
exports.FETCH_CLIENT_EMPLOYER_ERROR = FETCH_CLIENT_EMPLOYER_ERROR;
var FETCH_CLIENT_EMPLOYER_RESET = 'FETCH_CLIENT_EMPLOYER_RESET';
exports.FETCH_CLIENT_EMPLOYER_RESET = FETCH_CLIENT_EMPLOYER_RESET;
var FETCH_CLIENT_GENERAL_TERMS_SUCCESS = 'FETCH_CLIENT_GENERAL_TERMS_SUCCESS';
exports.FETCH_CLIENT_GENERAL_TERMS_SUCCESS = FETCH_CLIENT_GENERAL_TERMS_SUCCESS;
var FETCH_CLIENT_GENERAL_TERMS_START = 'FETCH_CLIENT_GENERAL_TERMS_START';
exports.FETCH_CLIENT_GENERAL_TERMS_START = FETCH_CLIENT_GENERAL_TERMS_START;
var FETCH_CLIENT_GENERAL_TERMS_ERROR = 'FETCH_CLIENT_GENERAL_TERMS_ERROR';
exports.FETCH_CLIENT_GENERAL_TERMS_ERROR = FETCH_CLIENT_GENERAL_TERMS_ERROR;
var FETCH_CLIENT_GENERAL_TERMS_RESET = 'FETCH_CLIENT_GENERAL_TERMS_RESET';
exports.FETCH_CLIENT_GENERAL_TERMS_RESET = FETCH_CLIENT_GENERAL_TERMS_RESET;
var FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_SUCCESS = 'FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_SUCCESS';
exports.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_SUCCESS = FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_SUCCESS;
var FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_START = 'FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_START';
exports.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_START = FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_START;
var FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_ERROR = 'FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_ERROR';
exports.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_ERROR = FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_ERROR;
var FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_RESET = 'FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_RESET';
exports.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_RESET = FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_RESET;
var FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_SUCCESS = 'FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_SUCCESS';
exports.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_SUCCESS = FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_SUCCESS;
var FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_START = 'FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_START';
exports.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_START = FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_START;
var FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_ERROR = 'FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_ERROR';
exports.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_ERROR = FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_ERROR;
var FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_RESET = 'FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_RESET';
exports.FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_RESET = FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_RESET;
var FETCH_CLIENT_LEGAL_TERMS_SUCCESS = 'FETCH_CLIENT_LEGAL_TERMS_SUCCESS';
exports.FETCH_CLIENT_LEGAL_TERMS_SUCCESS = FETCH_CLIENT_LEGAL_TERMS_SUCCESS;
var FETCH_CLIENT_LEGAL_TERMS_START = 'FETCH_CLIENT_LEGAL_TERMS_START';
exports.FETCH_CLIENT_LEGAL_TERMS_START = FETCH_CLIENT_LEGAL_TERMS_START;
var FETCH_CLIENT_LEGAL_TERMS_ERROR = 'FETCH_CLIENT_LEGAL_TERMS_ERROR';
exports.FETCH_CLIENT_LEGAL_TERMS_ERROR = FETCH_CLIENT_LEGAL_TERMS_ERROR;
var FETCH_CLIENT_LEGAL_TERMS_RESET = 'FETCH_CLIENT_LEGAL_TERMS_RESET';
exports.FETCH_CLIENT_LEGAL_TERMS_RESET = FETCH_CLIENT_LEGAL_TERMS_RESET;
var FETCH_CLIENT_LOANS_BY_LOANID_SUCCESS = 'FETCH_CLIENT_LOANS_BY_LOANID_SUCCESS';
exports.FETCH_CLIENT_LOANS_BY_LOANID_SUCCESS = FETCH_CLIENT_LOANS_BY_LOANID_SUCCESS;
var FETCH_CLIENT_LOANS_BY_LOANID_START = 'FETCH_CLIENT_LOANS_BY_LOANID_START';
exports.FETCH_CLIENT_LOANS_BY_LOANID_START = FETCH_CLIENT_LOANS_BY_LOANID_START;
var FETCH_CLIENT_LOANS_BY_LOANID_ERROR = 'FETCH_CLIENT_LOANS_BY_LOANID_ERROR';
exports.FETCH_CLIENT_LOANS_BY_LOANID_ERROR = FETCH_CLIENT_LOANS_BY_LOANID_ERROR;
var FETCH_CLIENT_LOANS_BY_LOANID_RESET = 'FETCH_CLIENT_LOANS_BY_LOANID_RESET';
exports.FETCH_CLIENT_LOANS_BY_LOANID_RESET = FETCH_CLIENT_LOANS_BY_LOANID_RESET;
var FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_SUCCESS = 'FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_SUCCESS';
exports.FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_SUCCESS = FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_SUCCESS;
var FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_START = 'FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_START';
exports.FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_START = FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_START;
var FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_ERROR = 'FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_ERROR';
exports.FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_ERROR = FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_ERROR;
var FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_RESET = 'FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_RESET';
exports.FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_RESET = FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_RESET;
var FETCH_CLIENT_LOANS_SUCCESS = 'FETCH_CLIENT_LOANS_SUCCESS';
exports.FETCH_CLIENT_LOANS_SUCCESS = FETCH_CLIENT_LOANS_SUCCESS;
var FETCH_CLIENT_LOANS_START = 'FETCH_CLIENT_LOANS_START';
exports.FETCH_CLIENT_LOANS_START = FETCH_CLIENT_LOANS_START;
var FETCH_CLIENT_LOANS_ERROR = 'FETCH_CLIENT_LOANS_ERROR';
exports.FETCH_CLIENT_LOANS_ERROR = FETCH_CLIENT_LOANS_ERROR;
var FETCH_CLIENT_LOANS_RESET = 'FETCH_CLIENT_LOANS_RESET';
exports.FETCH_CLIENT_LOANS_RESET = FETCH_CLIENT_LOANS_RESET;
var FETCH_CLIENT_MISSING_MANDATORY_FIELDS_SUCCESS = 'FETCH_CLIENT_MISSING_MANDATORY_FIELDS_SUCCESS';
exports.FETCH_CLIENT_MISSING_MANDATORY_FIELDS_SUCCESS = FETCH_CLIENT_MISSING_MANDATORY_FIELDS_SUCCESS;
var FETCH_CLIENT_MISSING_MANDATORY_FIELDS_START = 'FETCH_CLIENT_MISSING_MANDATORY_FIELDS_START';
exports.FETCH_CLIENT_MISSING_MANDATORY_FIELDS_START = FETCH_CLIENT_MISSING_MANDATORY_FIELDS_START;
var FETCH_CLIENT_MISSING_MANDATORY_FIELDS_ERROR = 'FETCH_CLIENT_MISSING_MANDATORY_FIELDS_ERROR';
exports.FETCH_CLIENT_MISSING_MANDATORY_FIELDS_ERROR = FETCH_CLIENT_MISSING_MANDATORY_FIELDS_ERROR;
var FETCH_CLIENT_MISSING_MANDATORY_FIELDS_RESET = 'FETCH_CLIENT_MISSING_MANDATORY_FIELDS_RESET';
exports.FETCH_CLIENT_MISSING_MANDATORY_FIELDS_RESET = FETCH_CLIENT_MISSING_MANDATORY_FIELDS_RESET;
var FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_SUCCESS = 'FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_SUCCESS';
exports.FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_SUCCESS = FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_SUCCESS;
var FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_START = 'FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_START';
exports.FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_START = FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_START;
var FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_ERROR = 'FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_ERROR';
exports.FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_ERROR = FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_ERROR;
var FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_RESET = 'FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_RESET';
exports.FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_RESET = FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_RESET;
var FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_SUCCESS = 'FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_SUCCESS';
exports.FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_SUCCESS = FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_SUCCESS;
var FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_START = 'FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_START';
exports.FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_START = FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_START;
var FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_ERROR = 'FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_ERROR';
exports.FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_ERROR = FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_ERROR;
var FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_RESET = 'FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_RESET';
exports.FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_RESET = FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_RESET;
var FETCH_CLIENT_PHONE_SUCCESS = 'FETCH_CLIENT_PHONE_SUCCESS';
exports.FETCH_CLIENT_PHONE_SUCCESS = FETCH_CLIENT_PHONE_SUCCESS;
var FETCH_CLIENT_PHONE_START = 'FETCH_CLIENT_PHONE_START';
exports.FETCH_CLIENT_PHONE_START = FETCH_CLIENT_PHONE_START;
var FETCH_CLIENT_PHONE_ERROR = 'FETCH_CLIENT_PHONE_ERROR';
exports.FETCH_CLIENT_PHONE_ERROR = FETCH_CLIENT_PHONE_ERROR;
var FETCH_CLIENT_PHONE_RESET = 'FETCH_CLIENT_PHONE_RESET';
exports.FETCH_CLIENT_PHONE_RESET = FETCH_CLIENT_PHONE_RESET;
var FETCH_CLIENT_SETTINGS_SUCCESS = 'FETCH_CLIENT_SETTINGS_SUCCESS';
exports.FETCH_CLIENT_SETTINGS_SUCCESS = FETCH_CLIENT_SETTINGS_SUCCESS;
var FETCH_CLIENT_SETTINGS_START = 'FETCH_CLIENT_SETTINGS_START';
exports.FETCH_CLIENT_SETTINGS_START = FETCH_CLIENT_SETTINGS_START;
var FETCH_CLIENT_SETTINGS_ERROR = 'FETCH_CLIENT_SETTINGS_ERROR';
exports.FETCH_CLIENT_SETTINGS_ERROR = FETCH_CLIENT_SETTINGS_ERROR;
var FETCH_CLIENT_SETTINGS_RESET = 'FETCH_CLIENT_SETTINGS_RESET';
exports.FETCH_CLIENT_SETTINGS_RESET = FETCH_CLIENT_SETTINGS_RESET;
var FETCH_CLIENT_SUCCESS = 'FETCH_CLIENT_SUCCESS';
exports.FETCH_CLIENT_SUCCESS = FETCH_CLIENT_SUCCESS;
var FETCH_CLIENT_START = 'FETCH_CLIENT_START';
exports.FETCH_CLIENT_START = FETCH_CLIENT_START;
var FETCH_CLIENT_ERROR = 'FETCH_CLIENT_ERROR';
exports.FETCH_CLIENT_ERROR = FETCH_CLIENT_ERROR;
var FETCH_CLIENT_RESET = 'FETCH_CLIENT_RESET';
exports.FETCH_CLIENT_RESET = FETCH_CLIENT_RESET;
var FETCH_DICTIONARY_COUNTRIES_SUCCESS = 'FETCH_DICTIONARY_COUNTRIES_SUCCESS';
exports.FETCH_DICTIONARY_COUNTRIES_SUCCESS = FETCH_DICTIONARY_COUNTRIES_SUCCESS;
var FETCH_DICTIONARY_COUNTRIES_START = 'FETCH_DICTIONARY_COUNTRIES_START';
exports.FETCH_DICTIONARY_COUNTRIES_START = FETCH_DICTIONARY_COUNTRIES_START;
var FETCH_DICTIONARY_COUNTRIES_ERROR = 'FETCH_DICTIONARY_COUNTRIES_ERROR';
exports.FETCH_DICTIONARY_COUNTRIES_ERROR = FETCH_DICTIONARY_COUNTRIES_ERROR;
var FETCH_DICTIONARY_COUNTRIES_RESET = 'FETCH_DICTIONARY_COUNTRIES_RESET';
exports.FETCH_DICTIONARY_COUNTRIES_RESET = FETCH_DICTIONARY_COUNTRIES_RESET;
var FETCH_EMPLOYMENT_PROFESSIONS_SUCCESS = 'FETCH_EMPLOYMENT_PROFESSIONS_SUCCESS';
exports.FETCH_EMPLOYMENT_PROFESSIONS_SUCCESS = FETCH_EMPLOYMENT_PROFESSIONS_SUCCESS;
var FETCH_EMPLOYMENT_PROFESSIONS_START = 'FETCH_EMPLOYMENT_PROFESSIONS_START';
exports.FETCH_EMPLOYMENT_PROFESSIONS_START = FETCH_EMPLOYMENT_PROFESSIONS_START;
var FETCH_EMPLOYMENT_PROFESSIONS_ERROR = 'FETCH_EMPLOYMENT_PROFESSIONS_ERROR';
exports.FETCH_EMPLOYMENT_PROFESSIONS_ERROR = FETCH_EMPLOYMENT_PROFESSIONS_ERROR;
var FETCH_EMPLOYMENT_PROFESSIONS_RESET = 'FETCH_EMPLOYMENT_PROFESSIONS_RESET';
exports.FETCH_EMPLOYMENT_PROFESSIONS_RESET = FETCH_EMPLOYMENT_PROFESSIONS_RESET;
var FETCH_FIRST_LOAN_LEGAL_TERMS_SUCCESS = 'FETCH_FIRST_LOAN_LEGAL_TERMS_SUCCESS';
exports.FETCH_FIRST_LOAN_LEGAL_TERMS_SUCCESS = FETCH_FIRST_LOAN_LEGAL_TERMS_SUCCESS;
var FETCH_FIRST_LOAN_LEGAL_TERMS_START = 'FETCH_FIRST_LOAN_LEGAL_TERMS_START';
exports.FETCH_FIRST_LOAN_LEGAL_TERMS_START = FETCH_FIRST_LOAN_LEGAL_TERMS_START;
var FETCH_FIRST_LOAN_LEGAL_TERMS_ERROR = 'FETCH_FIRST_LOAN_LEGAL_TERMS_ERROR';
exports.FETCH_FIRST_LOAN_LEGAL_TERMS_ERROR = FETCH_FIRST_LOAN_LEGAL_TERMS_ERROR;
var FETCH_FIRST_LOAN_LEGAL_TERMS_RESET = 'FETCH_FIRST_LOAN_LEGAL_TERMS_RESET';
exports.FETCH_FIRST_LOAN_LEGAL_TERMS_RESET = FETCH_FIRST_LOAN_LEGAL_TERMS_RESET;
var FETCH_GENERAL_TERMS_SUCCESS = 'FETCH_GENERAL_TERMS_SUCCESS';
exports.FETCH_GENERAL_TERMS_SUCCESS = FETCH_GENERAL_TERMS_SUCCESS;
var FETCH_GENERAL_TERMS_START = 'FETCH_GENERAL_TERMS_START';
exports.FETCH_GENERAL_TERMS_START = FETCH_GENERAL_TERMS_START;
var FETCH_GENERAL_TERMS_ERROR = 'FETCH_GENERAL_TERMS_ERROR';
exports.FETCH_GENERAL_TERMS_ERROR = FETCH_GENERAL_TERMS_ERROR;
var FETCH_GENERAL_TERMS_RESET = 'FETCH_GENERAL_TERMS_RESET';
exports.FETCH_GENERAL_TERMS_RESET = FETCH_GENERAL_TERMS_RESET;
var FETCH_NEXT_LOAN_LEGAL_TERMS_SUCCESS = 'FETCH_NEXT_LOAN_LEGAL_TERMS_SUCCESS';
exports.FETCH_NEXT_LOAN_LEGAL_TERMS_SUCCESS = FETCH_NEXT_LOAN_LEGAL_TERMS_SUCCESS;
var FETCH_NEXT_LOAN_LEGAL_TERMS_START = 'FETCH_NEXT_LOAN_LEGAL_TERMS_START';
exports.FETCH_NEXT_LOAN_LEGAL_TERMS_START = FETCH_NEXT_LOAN_LEGAL_TERMS_START;
var FETCH_NEXT_LOAN_LEGAL_TERMS_ERROR = 'FETCH_NEXT_LOAN_LEGAL_TERMS_ERROR';
exports.FETCH_NEXT_LOAN_LEGAL_TERMS_ERROR = FETCH_NEXT_LOAN_LEGAL_TERMS_ERROR;
var FETCH_NEXT_LOAN_LEGAL_TERMS_RESET = 'FETCH_NEXT_LOAN_LEGAL_TERMS_RESET';
exports.FETCH_NEXT_LOAN_LEGAL_TERMS_RESET = FETCH_NEXT_LOAN_LEGAL_TERMS_RESET;
var FETCH_REGISTRATION_SUCCESS = 'FETCH_REGISTRATION_SUCCESS';
exports.FETCH_REGISTRATION_SUCCESS = FETCH_REGISTRATION_SUCCESS;
var FETCH_REGISTRATION_START = 'FETCH_REGISTRATION_START';
exports.FETCH_REGISTRATION_START = FETCH_REGISTRATION_START;
var FETCH_REGISTRATION_ERROR = 'FETCH_REGISTRATION_ERROR';
exports.FETCH_REGISTRATION_ERROR = FETCH_REGISTRATION_ERROR;
var FETCH_REGISTRATION_RESET = 'FETCH_REGISTRATION_RESET';
exports.FETCH_REGISTRATION_RESET = FETCH_REGISTRATION_RESET;
var PATCH_CLIENT_APPLICATION_SUCCESS = 'PATCH_CLIENT_APPLICATION_SUCCESS';
exports.PATCH_CLIENT_APPLICATION_SUCCESS = PATCH_CLIENT_APPLICATION_SUCCESS;
var PATCH_CLIENT_APPLICATION_START = 'PATCH_CLIENT_APPLICATION_START';
exports.PATCH_CLIENT_APPLICATION_START = PATCH_CLIENT_APPLICATION_START;
var PATCH_CLIENT_APPLICATION_ERROR = 'PATCH_CLIENT_APPLICATION_ERROR';
exports.PATCH_CLIENT_APPLICATION_ERROR = PATCH_CLIENT_APPLICATION_ERROR;
var PATCH_CLIENT_APPLICATION_RESET = 'PATCH_CLIENT_APPLICATION_RESET';
exports.PATCH_CLIENT_APPLICATION_RESET = PATCH_CLIENT_APPLICATION_RESET;
var PATCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS = 'PATCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS';
exports.PATCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS = PATCH_CLIENT_BANK_ACCOUNT_NUMBER_SUCCESS;
var PATCH_CLIENT_BANK_ACCOUNT_NUMBER_START = 'PATCH_CLIENT_BANK_ACCOUNT_NUMBER_START';
exports.PATCH_CLIENT_BANK_ACCOUNT_NUMBER_START = PATCH_CLIENT_BANK_ACCOUNT_NUMBER_START;
var PATCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR = 'PATCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR';
exports.PATCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR = PATCH_CLIENT_BANK_ACCOUNT_NUMBER_ERROR;
var PATCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET = 'PATCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET';
exports.PATCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET = PATCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET;
var PATCH_CLIENT_EMAIL_CONFIRMATION_SUCCESS = 'PATCH_CLIENT_EMAIL_CONFIRMATION_SUCCESS';
exports.PATCH_CLIENT_EMAIL_CONFIRMATION_SUCCESS = PATCH_CLIENT_EMAIL_CONFIRMATION_SUCCESS;
var PATCH_CLIENT_EMAIL_CONFIRMATION_START = 'PATCH_CLIENT_EMAIL_CONFIRMATION_START';
exports.PATCH_CLIENT_EMAIL_CONFIRMATION_START = PATCH_CLIENT_EMAIL_CONFIRMATION_START;
var PATCH_CLIENT_EMAIL_CONFIRMATION_ERROR = 'PATCH_CLIENT_EMAIL_CONFIRMATION_ERROR';
exports.PATCH_CLIENT_EMAIL_CONFIRMATION_ERROR = PATCH_CLIENT_EMAIL_CONFIRMATION_ERROR;
var PATCH_CLIENT_EMAIL_CONFIRMATION_RESET = 'PATCH_CLIENT_EMAIL_CONFIRMATION_RESET';
exports.PATCH_CLIENT_EMAIL_CONFIRMATION_RESET = PATCH_CLIENT_EMAIL_CONFIRMATION_RESET;
var PATCH_CLIENT_EMPLOYER_SUCCESS = 'PATCH_CLIENT_EMPLOYER_SUCCESS';
exports.PATCH_CLIENT_EMPLOYER_SUCCESS = PATCH_CLIENT_EMPLOYER_SUCCESS;
var PATCH_CLIENT_EMPLOYER_START = 'PATCH_CLIENT_EMPLOYER_START';
exports.PATCH_CLIENT_EMPLOYER_START = PATCH_CLIENT_EMPLOYER_START;
var PATCH_CLIENT_EMPLOYER_ERROR = 'PATCH_CLIENT_EMPLOYER_ERROR';
exports.PATCH_CLIENT_EMPLOYER_ERROR = PATCH_CLIENT_EMPLOYER_ERROR;
var PATCH_CLIENT_EMPLOYER_RESET = 'PATCH_CLIENT_EMPLOYER_RESET';
exports.PATCH_CLIENT_EMPLOYER_RESET = PATCH_CLIENT_EMPLOYER_RESET;
var PATCH_CLIENT_MISSING_MANDATORY_FIELDS_SUCCESS = 'PATCH_CLIENT_MISSING_MANDATORY_FIELDS_SUCCESS';
exports.PATCH_CLIENT_MISSING_MANDATORY_FIELDS_SUCCESS = PATCH_CLIENT_MISSING_MANDATORY_FIELDS_SUCCESS;
var PATCH_CLIENT_MISSING_MANDATORY_FIELDS_START = 'PATCH_CLIENT_MISSING_MANDATORY_FIELDS_START';
exports.PATCH_CLIENT_MISSING_MANDATORY_FIELDS_START = PATCH_CLIENT_MISSING_MANDATORY_FIELDS_START;
var PATCH_CLIENT_MISSING_MANDATORY_FIELDS_ERROR = 'PATCH_CLIENT_MISSING_MANDATORY_FIELDS_ERROR';
exports.PATCH_CLIENT_MISSING_MANDATORY_FIELDS_ERROR = PATCH_CLIENT_MISSING_MANDATORY_FIELDS_ERROR;
var PATCH_CLIENT_MISSING_MANDATORY_FIELDS_RESET = 'PATCH_CLIENT_MISSING_MANDATORY_FIELDS_RESET';
exports.PATCH_CLIENT_MISSING_MANDATORY_FIELDS_RESET = PATCH_CLIENT_MISSING_MANDATORY_FIELDS_RESET;
var PATCH_CLIENT_PASSWORD_SUCCESS = 'PATCH_CLIENT_PASSWORD_SUCCESS';
exports.PATCH_CLIENT_PASSWORD_SUCCESS = PATCH_CLIENT_PASSWORD_SUCCESS;
var PATCH_CLIENT_PASSWORD_START = 'PATCH_CLIENT_PASSWORD_START';
exports.PATCH_CLIENT_PASSWORD_START = PATCH_CLIENT_PASSWORD_START;
var PATCH_CLIENT_PASSWORD_ERROR = 'PATCH_CLIENT_PASSWORD_ERROR';
exports.PATCH_CLIENT_PASSWORD_ERROR = PATCH_CLIENT_PASSWORD_ERROR;
var PATCH_CLIENT_PASSWORD_RESET = 'PATCH_CLIENT_PASSWORD_RESET';
exports.PATCH_CLIENT_PASSWORD_RESET = PATCH_CLIENT_PASSWORD_RESET;
var PATCH_CLIENT_PHONE_CONFIRMATION_SUCCESS = 'PATCH_CLIENT_PHONE_CONFIRMATION_SUCCESS';
exports.PATCH_CLIENT_PHONE_CONFIRMATION_SUCCESS = PATCH_CLIENT_PHONE_CONFIRMATION_SUCCESS;
var PATCH_CLIENT_PHONE_CONFIRMATION_START = 'PATCH_CLIENT_PHONE_CONFIRMATION_START';
exports.PATCH_CLIENT_PHONE_CONFIRMATION_START = PATCH_CLIENT_PHONE_CONFIRMATION_START;
var PATCH_CLIENT_PHONE_CONFIRMATION_ERROR = 'PATCH_CLIENT_PHONE_CONFIRMATION_ERROR';
exports.PATCH_CLIENT_PHONE_CONFIRMATION_ERROR = PATCH_CLIENT_PHONE_CONFIRMATION_ERROR;
var PATCH_CLIENT_PHONE_CONFIRMATION_RESET = 'PATCH_CLIENT_PHONE_CONFIRMATION_RESET';
exports.PATCH_CLIENT_PHONE_CONFIRMATION_RESET = PATCH_CLIENT_PHONE_CONFIRMATION_RESET;
var PATCH_CLIENT_PHONE_SUCCESS = 'PATCH_CLIENT_PHONE_SUCCESS';
exports.PATCH_CLIENT_PHONE_SUCCESS = PATCH_CLIENT_PHONE_SUCCESS;
var PATCH_CLIENT_PHONE_START = 'PATCH_CLIENT_PHONE_START';
exports.PATCH_CLIENT_PHONE_START = PATCH_CLIENT_PHONE_START;
var PATCH_CLIENT_PHONE_ERROR = 'PATCH_CLIENT_PHONE_ERROR';
exports.PATCH_CLIENT_PHONE_ERROR = PATCH_CLIENT_PHONE_ERROR;
var PATCH_CLIENT_PHONE_RESET = 'PATCH_CLIENT_PHONE_RESET';
exports.PATCH_CLIENT_PHONE_RESET = PATCH_CLIENT_PHONE_RESET;
var PATCH_CLIENT_PROFILE_SUCCESS = 'PATCH_CLIENT_PROFILE_SUCCESS';
exports.PATCH_CLIENT_PROFILE_SUCCESS = PATCH_CLIENT_PROFILE_SUCCESS;
var PATCH_CLIENT_PROFILE_START = 'PATCH_CLIENT_PROFILE_START';
exports.PATCH_CLIENT_PROFILE_START = PATCH_CLIENT_PROFILE_START;
var PATCH_CLIENT_PROFILE_ERROR = 'PATCH_CLIENT_PROFILE_ERROR';
exports.PATCH_CLIENT_PROFILE_ERROR = PATCH_CLIENT_PROFILE_ERROR;
var PATCH_CLIENT_PROFILE_RESET = 'PATCH_CLIENT_PROFILE_RESET';
exports.PATCH_CLIENT_PROFILE_RESET = PATCH_CLIENT_PROFILE_RESET;
var PATCH_CLIENT_SETTINGS_SUCCESS = 'PATCH_CLIENT_SETTINGS_SUCCESS';
exports.PATCH_CLIENT_SETTINGS_SUCCESS = PATCH_CLIENT_SETTINGS_SUCCESS;
var PATCH_CLIENT_SETTINGS_START = 'PATCH_CLIENT_SETTINGS_START';
exports.PATCH_CLIENT_SETTINGS_START = PATCH_CLIENT_SETTINGS_START;
var PATCH_CLIENT_SETTINGS_ERROR = 'PATCH_CLIENT_SETTINGS_ERROR';
exports.PATCH_CLIENT_SETTINGS_ERROR = PATCH_CLIENT_SETTINGS_ERROR;
var PATCH_CLIENT_SETTINGS_RESET = 'PATCH_CLIENT_SETTINGS_RESET';
exports.PATCH_CLIENT_SETTINGS_RESET = PATCH_CLIENT_SETTINGS_RESET;
var SEND_CLIENT_APPLICATION_SUCCESS = 'SEND_CLIENT_APPLICATION_SUCCESS';
exports.SEND_CLIENT_APPLICATION_SUCCESS = SEND_CLIENT_APPLICATION_SUCCESS;
var SEND_CLIENT_APPLICATION_START = 'SEND_CLIENT_APPLICATION_START';
exports.SEND_CLIENT_APPLICATION_START = SEND_CLIENT_APPLICATION_START;
var SEND_CLIENT_APPLICATION_ERROR = 'SEND_CLIENT_APPLICATION_ERROR';
exports.SEND_CLIENT_APPLICATION_ERROR = SEND_CLIENT_APPLICATION_ERROR;
var SEND_CLIENT_APPLICATION_RESET = 'SEND_CLIENT_APPLICATION_RESET';
exports.SEND_CLIENT_APPLICATION_RESET = SEND_CLIENT_APPLICATION_RESET;
var SEND_CLIENT_COOKIES_SUCCESS = 'SEND_CLIENT_COOKIES_SUCCESS';
exports.SEND_CLIENT_COOKIES_SUCCESS = SEND_CLIENT_COOKIES_SUCCESS;
var SEND_CLIENT_COOKIES_START = 'SEND_CLIENT_COOKIES_START';
exports.SEND_CLIENT_COOKIES_START = SEND_CLIENT_COOKIES_START;
var SEND_CLIENT_COOKIES_ERROR = 'SEND_CLIENT_COOKIES_ERROR';
exports.SEND_CLIENT_COOKIES_ERROR = SEND_CLIENT_COOKIES_ERROR;
var SEND_CLIENT_COOKIES_RESET = 'SEND_CLIENT_COOKIES_RESET';
exports.SEND_CLIENT_COOKIES_RESET = SEND_CLIENT_COOKIES_RESET;
var SEND_CLIENT_EMAIL_SUCCESS = 'SEND_CLIENT_EMAIL_SUCCESS';
exports.SEND_CLIENT_EMAIL_SUCCESS = SEND_CLIENT_EMAIL_SUCCESS;
var SEND_CLIENT_EMAIL_START = 'SEND_CLIENT_EMAIL_START';
exports.SEND_CLIENT_EMAIL_START = SEND_CLIENT_EMAIL_START;
var SEND_CLIENT_EMAIL_ERROR = 'SEND_CLIENT_EMAIL_ERROR';
exports.SEND_CLIENT_EMAIL_ERROR = SEND_CLIENT_EMAIL_ERROR;
var SEND_CLIENT_EMAIL_RESET = 'SEND_CLIENT_EMAIL_RESET';
exports.SEND_CLIENT_EMAIL_RESET = SEND_CLIENT_EMAIL_RESET;
var SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_SUCCESS = 'SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_SUCCESS';
exports.SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_SUCCESS = SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_SUCCESS;
var SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_START = 'SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_START';
exports.SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_START = SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_START;
var SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_ERROR = 'SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_ERROR';
exports.SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_ERROR = SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_ERROR;
var SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_RESET = 'SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_RESET';
exports.SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_RESET = SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_RESET;
var SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_SUCCESS = 'SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_SUCCESS';
exports.SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_SUCCESS = SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_SUCCESS;
var SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_START = 'SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_START';
exports.SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_START = SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_START;
var SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_ERROR = 'SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_ERROR';
exports.SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_ERROR = SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_ERROR;
var SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_RESET = 'SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_RESET';
exports.SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_RESET = SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_RESET;
var SEND_CLIENT_PHONE_SUCCESS = 'SEND_CLIENT_PHONE_SUCCESS';
exports.SEND_CLIENT_PHONE_SUCCESS = SEND_CLIENT_PHONE_SUCCESS;
var SEND_CLIENT_PHONE_START = 'SEND_CLIENT_PHONE_START';
exports.SEND_CLIENT_PHONE_START = SEND_CLIENT_PHONE_START;
var SEND_CLIENT_PHONE_ERROR = 'SEND_CLIENT_PHONE_ERROR';
exports.SEND_CLIENT_PHONE_ERROR = SEND_CLIENT_PHONE_ERROR;
var SEND_CLIENT_PHONE_RESET = 'SEND_CLIENT_PHONE_RESET';
exports.SEND_CLIENT_PHONE_RESET = SEND_CLIENT_PHONE_RESET;
var SEND_CLIENT_TEMPORARY_PASSWORD_SUCCESS = 'SEND_CLIENT_TEMPORARY_PASSWORD_SUCCESS';
exports.SEND_CLIENT_TEMPORARY_PASSWORD_SUCCESS = SEND_CLIENT_TEMPORARY_PASSWORD_SUCCESS;
var SEND_CLIENT_TEMPORARY_PASSWORD_START = 'SEND_CLIENT_TEMPORARY_PASSWORD_START';
exports.SEND_CLIENT_TEMPORARY_PASSWORD_START = SEND_CLIENT_TEMPORARY_PASSWORD_START;
var SEND_CLIENT_TEMPORARY_PASSWORD_ERROR = 'SEND_CLIENT_TEMPORARY_PASSWORD_ERROR';
exports.SEND_CLIENT_TEMPORARY_PASSWORD_ERROR = SEND_CLIENT_TEMPORARY_PASSWORD_ERROR;
var SEND_CLIENT_TEMPORARY_PASSWORD_RESET = 'SEND_CLIENT_TEMPORARY_PASSWORD_RESET';
exports.SEND_CLIENT_TEMPORARY_PASSWORD_RESET = SEND_CLIENT_TEMPORARY_PASSWORD_RESET;
var SEND_REGISTRATION_SUCCESS = 'SEND_REGISTRATION_SUCCESS';
exports.SEND_REGISTRATION_SUCCESS = SEND_REGISTRATION_SUCCESS;
var SEND_REGISTRATION_START = 'SEND_REGISTRATION_START';
exports.SEND_REGISTRATION_START = SEND_REGISTRATION_START;
var SEND_REGISTRATION_ERROR = 'SEND_REGISTRATION_ERROR';
exports.SEND_REGISTRATION_ERROR = SEND_REGISTRATION_ERROR;
var SEND_REGISTRATION_RESET = 'SEND_REGISTRATION_RESET';
exports.SEND_REGISTRATION_RESET = SEND_REGISTRATION_RESET;
var SEND_TOKEN_APPLICATION_SUCCESS = 'SEND_TOKEN_APPLICATION_SUCCESS';
exports.SEND_TOKEN_APPLICATION_SUCCESS = SEND_TOKEN_APPLICATION_SUCCESS;
var SEND_TOKEN_APPLICATION_START = 'SEND_TOKEN_APPLICATION_START';
exports.SEND_TOKEN_APPLICATION_START = SEND_TOKEN_APPLICATION_START;
var SEND_TOKEN_APPLICATION_ERROR = 'SEND_TOKEN_APPLICATION_ERROR';
exports.SEND_TOKEN_APPLICATION_ERROR = SEND_TOKEN_APPLICATION_ERROR;
var SEND_TOKEN_APPLICATION_RESET = 'SEND_TOKEN_APPLICATION_RESET';
exports.SEND_TOKEN_APPLICATION_RESET = SEND_TOKEN_APPLICATION_RESET;
var SEND_TOKEN_BASIC_SUCCESS = 'SEND_TOKEN_BASIC_SUCCESS';
exports.SEND_TOKEN_BASIC_SUCCESS = SEND_TOKEN_BASIC_SUCCESS;
var SEND_TOKEN_BASIC_START = 'SEND_TOKEN_BASIC_START';
exports.SEND_TOKEN_BASIC_START = SEND_TOKEN_BASIC_START;
var SEND_TOKEN_BASIC_ERROR = 'SEND_TOKEN_BASIC_ERROR';
exports.SEND_TOKEN_BASIC_ERROR = SEND_TOKEN_BASIC_ERROR;
var SEND_TOKEN_BASIC_RESET = 'SEND_TOKEN_BASIC_RESET';
exports.SEND_TOKEN_BASIC_RESET = SEND_TOKEN_BASIC_RESET; /**
                                                         * GET /application/constraints
                                                         *
                                                         * Load response by connectState:
                                                         * @connectState({
                                                         *   state: {
                                                         *     constraints: ['api', 'fetch', 'application', 'constraints', 'query']
                                                         *   },
                                                         *   actions: {
                                                         *     fetchApplicationConstraints: ['api', 'fetchApplicationConstraints']
                                                         *   }
                                                         * })
                                                         *
                                                         * In component you can get to query result by:
                                                         * this.props.constraints.data    #=> Immutable.Map
                                                         * this.props.constraints.fetched #=> boolean
                                                         * this.props.constraints.pending #=> boolean
                                                         * this.props.constraints.error   #=> null or something returned from action
                                                         *
                                                         * @method fetchApplicationConstraints
                                                         *
                                                         * @return {fetchApplicationConstraints} src/common/api/response/fetchApplicationConstraints.js
                                                         */
function fetchApplicationConstraints() {
  return function (_ref) {
    var httpGet = _ref.httpGet;
    return {
      type: 'FETCH_APPLICATION_CONSTRAINTS',
      payload: {
        promise: httpGet('/application/constraints')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchApplicationConstraints()
  */
function fetchApplicationConstraintsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_APPLICATION_CONSTRAINTS_RESET',
    hardReset: hard
  };
} /**
  * GET /application/credit-limit
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     creditLimit: ['api', 'fetch', 'application', 'creditLimit']
  *   },
  *   actions: {
  *     fetchApplicationCreditLimit: ['api', 'fetchApplicationCreditLimit']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [age]
  * so in component you can get to query result by:
  * this.props.creditLimit.getIn([age.toString(), 'data'])    #=> Immutable.Map
  * this.props.creditLimit.getIn([age.toString(), 'fetched']) #=> boolean
  * this.props.creditLimit.getIn([age.toString(), 'pending']) #=> boolean
  * this.props.creditLimit.getIn([age.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.creditLimit.getIn([age.toString()]).data       #=> Immutable.Map
  * this.props.creditLimit.getIn([age.toString()]).fetched    #=> boolean
  * this.props.creditLimit.getIn([age.toString()]).pending    #=> boolean
  * this.props.creditLimit.getIn([age.toString()]).error      #=> null or something returned from action
  *
  * @method fetchApplicationCreditLimit
  *
  * @param  age  {Int}
  *
  * @return {fetchApplicationCreditLimit} src/common/api/response/fetchApplicationCreditLimit.js
  */
function fetchApplicationCreditLimit(age) {
  return function (_ref2) {
    var httpGet = _ref2.httpGet;
    return {
      type: 'FETCH_APPLICATION_CREDIT_LIMIT',
      meta: {
        age: age
      },
      payload: {
        promise: httpGet('/application/credit-limit', {
          age: age
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchApplicationCreditLimit(age)
  */
function fetchApplicationCreditLimitReset(age) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'FETCH_APPLICATION_CREDIT_LIMIT_RESET',
    meta: {
      age: age
    },
    hardReset: hard
  };
} /**
  * GET /application/first-loan-offer
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     firstLoanOffer: ['api', 'fetch', 'application', 'firstLoanOffer']
  *   },
  *   actions: {
  *     fetchApplicationFirstLoanOffer: ['api', 'fetchApplicationFirstLoanOffer']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [amount, term, productNumber]
  * so in component you can get to query result by:
  * this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'data'])    #=> Immutable.Map
  * this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'fetched']) #=> boolean
  * this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'pending']) #=> boolean
  * this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString()]).data       #=> Immutable.Map
  * this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString()]).fetched    #=> boolean
  * this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString()]).pending    #=> boolean
  * this.props.firstLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString()]).error      #=> null or something returned from action
  *
  * @method fetchApplicationFirstLoanOffer
  *
  * @param  amount         {Int}
  * @param  term           {Int}
  * @param  productNumber  {String}
  *
  * @return {fetchApplicationFirstLoanOffer} src/common/api/response/fetchApplicationFirstLoanOffer.js
  */
function fetchApplicationFirstLoanOffer(amount, term, productNumber) {
  return function (_ref3) {
    var httpGet = _ref3.httpGet;
    return {
      type: 'FETCH_APPLICATION_FIRST_LOAN_OFFER',
      meta: {
        amount: amount,
        term: term,
        productNumber: productNumber
      },
      payload: {
        promise: httpGet('/application/first-loan-offer', {
          amount: amount,
          term: term,
          productNumber: productNumber
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchApplicationFirstLoanOffer(amount, term, productNumber)
  */
function fetchApplicationFirstLoanOfferReset(amount, term, productNumber) {
  var hard = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
  return {
    type: 'FETCH_APPLICATION_FIRST_LOAN_OFFER_RESET',
    meta: {
      amount: amount,
      term: term,
      productNumber: productNumber
    },
    hardReset: hard
  };
} /**
  * GET /application/first-loan-offer/extra-service-fee
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     extraServiceFee: ['api', 'fetch', 'application', 'firstLoanOffer', 'extraServiceFee']
  *   },
  *   actions: {
  *     fetchApplicationFirstLoanOfferExtraServiceFee: ['api', 'fetchApplicationFirstLoanOfferExtraServiceFee']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [amount, extraServiceRequired, term]
  * so in component you can get to query result by:
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'data'])    #=> Immutable.Map
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'fetched']) #=> boolean
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'pending']) #=> boolean
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).data       #=> Immutable.Map
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).fetched    #=> boolean
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).pending    #=> boolean
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).error      #=> null or something returned from action
  *
  * @method fetchApplicationFirstLoanOfferExtraServiceFee
  *
  * @param  amount                {Int}
  * @param  extraServiceRequired  {Boolean}
  * @param  term                  {Int}
  *
  * @return {fetchApplicationFirstLoanOfferExtraServiceFee} src/common/api/response/fetchApplicationFirstLoanOfferExtraServiceFee.js
  */
function fetchApplicationFirstLoanOfferExtraServiceFee(amount, extraServiceRequired, term) {
  return function (_ref4) {
    var httpGet = _ref4.httpGet;
    return {
      type: 'FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE',
      meta: {
        amount: amount,
        extraServiceRequired: extraServiceRequired,
        term: term
      },
      payload: {
        promise: httpGet('/application/first-loan-offer/extra-service-fee', {
          amount: amount,
          extraServiceRequired: extraServiceRequired,
          term: term
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchApplicationFirstLoanOfferExtraServiceFee(amount, extraServiceRequired, term)
  */
function fetchApplicationFirstLoanOfferExtraServiceFeeReset(amount, extraServiceRequired, term) {
  var hard = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
  return {
    type: 'FETCH_APPLICATION_FIRST_LOAN_OFFER_EXTRA_SERVICE_FEE_RESET',
    meta: {
      amount: amount,
      extraServiceRequired: extraServiceRequired,
      term: term
    },
    hardReset: hard
  };
} /**
  * GET /application/login/{accessId}
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     login: ['api', 'fetch', 'application', 'login']
  *   },
  *   actions: {
  *     fetchApplicationLoginByAccessid: ['api', 'fetchApplicationLoginByAccessid']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [accessId]
  * so in component you can get to query result by:
  * this.props.login.getIn([accessId.toString(), 'data'])    #=> Immutable.Map
  * this.props.login.getIn([accessId.toString(), 'fetched']) #=> boolean
  * this.props.login.getIn([accessId.toString(), 'pending']) #=> boolean
  * this.props.login.getIn([accessId.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.login.getIn([accessId.toString()]).data       #=> Immutable.Map
  * this.props.login.getIn([accessId.toString()]).fetched    #=> boolean
  * this.props.login.getIn([accessId.toString()]).pending    #=> boolean
  * this.props.login.getIn([accessId.toString()]).error      #=> null or something returned from action
  *
  * @method fetchApplicationLoginByAccessid
  *
  * @param  accessId  {?}
  *
  * @return {fetchApplicationLoginByAccessid} src/common/api/response/fetchApplicationLoginByAccessid.js
  */
function fetchApplicationLoginByAccessid(accessId) {
  return function (_ref5) {
    var httpGet = _ref5.httpGet;
    return {
      type: 'FETCH_APPLICATION_LOGIN_BY_ACCESSID',
      meta: {
        accessId: accessId
      },
      payload: {
        promise: httpGet('/application/login/' + accessId)
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchApplicationLoginByAccessid(accessId)
  */
function fetchApplicationLoginByAccessidReset(accessId) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'FETCH_APPLICATION_LOGIN_BY_ACCESSID_RESET',
    meta: {
      accessId: accessId
    },
    hardReset: hard
  };
} /**
  * GET /application/next-loan-offer
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     nextLoanOffer: ['api', 'fetch', 'application', 'nextLoanOffer']
  *   },
  *   actions: {
  *     fetchApplicationNextLoanOffer: ['api', 'fetchApplicationNextLoanOffer']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [amount, term, productNumber]
  * so in component you can get to query result by:
  * this.props.nextLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'data'])    #=> Immutable.Map
  * this.props.nextLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'fetched']) #=> boolean
  * this.props.nextLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'pending']) #=> boolean
  * this.props.nextLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.nextLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString()]).data       #=> Immutable.Map
  * this.props.nextLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString()]).fetched    #=> boolean
  * this.props.nextLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString()]).pending    #=> boolean
  * this.props.nextLoanOffer.getIn([amount.toString(), term.toString(), productNumber.toString()]).error      #=> null or something returned from action
  *
  * @method fetchApplicationNextLoanOffer
  *
  * @param  amount         {Int}
  * @param  term           {Int}
  * @param  productNumber  {String}
  *
  * @return {fetchApplicationNextLoanOffer} src/common/api/response/fetchApplicationNextLoanOffer.js
  */
function fetchApplicationNextLoanOffer(amount, term, productNumber) {
  return function (_ref6) {
    var httpGet = _ref6.httpGet;
    return {
      type: 'FETCH_APPLICATION_NEXT_LOAN_OFFER',
      meta: {
        amount: amount,
        term: term,
        productNumber: productNumber
      },
      payload: {
        promise: httpGet('/application/next-loan-offer', {
          amount: amount,
          term: term,
          productNumber: productNumber
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchApplicationNextLoanOffer(amount, term, productNumber)
  */
function fetchApplicationNextLoanOfferReset(amount, term, productNumber) {
  var hard = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
  return {
    type: 'FETCH_APPLICATION_NEXT_LOAN_OFFER_RESET',
    meta: {
      amount: amount,
      term: term,
      productNumber: productNumber
    },
    hardReset: hard
  };
} /**
  * GET /application/next-loan-offer/extra-service-fee
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     extraServiceFee: ['api', 'fetch', 'application', 'nextLoanOffer', 'extraServiceFee']
  *   },
  *   actions: {
  *     fetchApplicationNextLoanOfferExtraServiceFee: ['api', 'fetchApplicationNextLoanOfferExtraServiceFee']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [amount, extraServiceRequired, term]
  * so in component you can get to query result by:
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'data'])    #=> Immutable.Map
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'fetched']) #=> boolean
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'pending']) #=> boolean
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).data       #=> Immutable.Map
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).fetched    #=> boolean
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).pending    #=> boolean
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).error      #=> null or something returned from action
  *
  * @method fetchApplicationNextLoanOfferExtraServiceFee
  *
  * @param  amount                {Int}
  * @param  extraServiceRequired  {Boolean}
  * @param  term                  {Int}
  *
  * @return {fetchApplicationNextLoanOfferExtraServiceFee} src/common/api/response/fetchApplicationNextLoanOfferExtraServiceFee.js
  */
function fetchApplicationNextLoanOfferExtraServiceFee(amount, extraServiceRequired, term) {
  return function (_ref7) {
    var httpGet = _ref7.httpGet;
    return {
      type: 'FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE',
      meta: {
        amount: amount,
        extraServiceRequired: extraServiceRequired,
        term: term
      },
      payload: {
        promise: httpGet('/application/next-loan-offer/extra-service-fee', {
          amount: amount,
          extraServiceRequired: extraServiceRequired,
          term: term
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchApplicationNextLoanOfferExtraServiceFee(amount, extraServiceRequired, term)
  */
function fetchApplicationNextLoanOfferExtraServiceFeeReset(amount, extraServiceRequired, term) {
  var hard = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
  return {
    type: 'FETCH_APPLICATION_NEXT_LOAN_OFFER_EXTRA_SERVICE_FEE_RESET',
    meta: {
      amount: amount,
      extraServiceRequired: extraServiceRequired,
      term: term
    },
    hardReset: hard
  };
} /**
  * GET /client
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     client: ['api', 'fetch', 'client', 'query']
  *   },
  *   actions: {
  *     fetchClient: ['api', 'fetchClient']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.client.data    #=> Immutable.Map
  * this.props.client.fetched #=> boolean
  * this.props.client.pending #=> boolean
  * this.props.client.error   #=> null or something returned from action
  *
  * @method fetchClient
  *
  * @return {fetchClient} src/common/api/response/fetchClient.js
  */
function fetchClient() {
  return function (_ref8) {
    var httpGet = _ref8.httpGet;
    return {
      type: 'FETCH_CLIENT',
      payload: {
        promise: httpGet('/client')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClient()
  */
function fetchClientReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_RESET',
    hardReset: hard
  };
} /**
  * GET /client/agreements/preliminary
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     preliminary: ['api', 'fetch', 'client', 'agreements', 'preliminary']
  *   },
  *   actions: {
  *     fetchClientAgreementsPreliminary: ['api', 'fetchClientAgreementsPreliminary']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [amount, fileType, firstPaymentDueDate, inline, monthlyPayment, term]
  * so in component you can get to query result by:
  * this.props.preliminary.getIn([amount.toString(), fileType.toString(), firstPaymentDueDate.toString(), inline.toString(), monthlyPayment.toString(), term.toString(), 'data'])    #=> Immutable.Map
  * this.props.preliminary.getIn([amount.toString(), fileType.toString(), firstPaymentDueDate.toString(), inline.toString(), monthlyPayment.toString(), term.toString(), 'fetched']) #=> boolean
  * this.props.preliminary.getIn([amount.toString(), fileType.toString(), firstPaymentDueDate.toString(), inline.toString(), monthlyPayment.toString(), term.toString(), 'pending']) #=> boolean
  * this.props.preliminary.getIn([amount.toString(), fileType.toString(), firstPaymentDueDate.toString(), inline.toString(), monthlyPayment.toString(), term.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.preliminary.getIn([amount.toString(), fileType.toString(), firstPaymentDueDate.toString(), inline.toString(), monthlyPayment.toString(), term.toString()]).data       #=> Immutable.Map
  * this.props.preliminary.getIn([amount.toString(), fileType.toString(), firstPaymentDueDate.toString(), inline.toString(), monthlyPayment.toString(), term.toString()]).fetched    #=> boolean
  * this.props.preliminary.getIn([amount.toString(), fileType.toString(), firstPaymentDueDate.toString(), inline.toString(), monthlyPayment.toString(), term.toString()]).pending    #=> boolean
  * this.props.preliminary.getIn([amount.toString(), fileType.toString(), firstPaymentDueDate.toString(), inline.toString(), monthlyPayment.toString(), term.toString()]).error      #=> null or something returned from action
  *
  * @method fetchClientAgreementsPreliminary
  *
  * @param  amount               {String}
  * @param  fileType             {String}
  * @param  firstPaymentDueDate  {String}
  * @param  inline               {Boolean}
  * @param  monthlyPayment       {String}
  * @param  term                 {Int}
  *
  */
function fetchClientAgreementsPreliminary(amount, fileType, firstPaymentDueDate, inline, monthlyPayment, term) {
  return function (_ref9) {
    var httpGet = _ref9.httpGet;
    return {
      type: 'FETCH_CLIENT_AGREEMENTS_PRELIMINARY',
      meta: {
        amount: amount,
        fileType: fileType,
        firstPaymentDueDate: firstPaymentDueDate,
        inline: inline,
        monthlyPayment: monthlyPayment,
        term: term
      },
      payload: {
        promise: httpGet('/client/agreements/preliminary', {
          amount: amount,
          fileType: fileType,
          firstPaymentDueDate: firstPaymentDueDate,
          inline: inline,
          monthlyPayment: monthlyPayment,
          term: term
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientAgreementsPreliminary(amount, fileType, firstPaymentDueDate, inline, monthlyPayment, term)
  */
function fetchClientAgreementsPreliminaryReset(amount, fileType, firstPaymentDueDate, inline, monthlyPayment, term) {
  var hard = arguments.length <= 6 || arguments[6] === undefined ? false : arguments[6];
  return {
    type: 'FETCH_CLIENT_AGREEMENTS_PRELIMINARY_RESET',
    meta: {
      amount: amount,
      fileType: fileType,
      firstPaymentDueDate: firstPaymentDueDate,
      inline: inline,
      monthlyPayment: monthlyPayment,
      term: term
    },
    hardReset: hard
  };
} /**
  * GET /client/application
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     application: ['api', 'fetch', 'client', 'application', 'query']
  *   },
  *   actions: {
  *     fetchClientApplication: ['api', 'fetchClientApplication']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.application.data    #=> Immutable.Map
  * this.props.application.fetched #=> boolean
  * this.props.application.pending #=> boolean
  * this.props.application.error   #=> null or something returned from action
  *
  * @method fetchClientApplication
  *
  * @return {fetchClientApplication} src/common/api/response/fetchClientApplication.js
  */
function fetchClientApplication() {
  return function (_ref10) {
    var httpGet = _ref10.httpGet;
    return {
      type: 'FETCH_CLIENT_APPLICATION',
      payload: {
        promise: httpGet('/client/application')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientApplication()
  */
function fetchClientApplicationReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_APPLICATION_RESET',
    hardReset: hard
  };
} /**
  * GET /client/application/constraints
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     constraints: ['api', 'fetch', 'client', 'application', 'constraints', 'query']
  *   },
  *   actions: {
  *     fetchClientApplicationConstraints: ['api', 'fetchClientApplicationConstraints']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.constraints.data    #=> Immutable.Map
  * this.props.constraints.fetched #=> boolean
  * this.props.constraints.pending #=> boolean
  * this.props.constraints.error   #=> null or something returned from action
  *
  * @method fetchClientApplicationConstraints
  *
  * @return {fetchClientApplicationConstraints} src/common/api/response/fetchClientApplicationConstraints.js
  */
function fetchClientApplicationConstraints() {
  return function (_ref11) {
    var httpGet = _ref11.httpGet;
    return {
      type: 'FETCH_CLIENT_APPLICATION_CONSTRAINTS',
      payload: {
        promise: httpGet('/client/application/constraints')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientApplicationConstraints()
  */
function fetchClientApplicationConstraintsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_APPLICATION_CONSTRAINTS_RESET',
    hardReset: hard
  };
} /**
  * GET /client/application/offer
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     offer: ['api', 'fetch', 'client', 'application', 'offer']
  *   },
  *   actions: {
  *     fetchClientApplicationOffer: ['api', 'fetchClientApplicationOffer']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [amount, term, productNumber]
  * so in component you can get to query result by:
  * this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'data'])    #=> Immutable.Map
  * this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'fetched']) #=> boolean
  * this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'pending']) #=> boolean
  * this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString()]).data       #=> Immutable.Map
  * this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString()]).fetched    #=> boolean
  * this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString()]).pending    #=> boolean
  * this.props.offer.getIn([amount.toString(), term.toString(), productNumber.toString()]).error      #=> null or something returned from action
  *
  * @method fetchClientApplicationOffer
  *
  * @param  amount         {Int}
  * @param  term           {Int}
  * @param  productNumber  {String}
  *
  * @return {fetchClientApplicationOffer} src/common/api/response/fetchClientApplicationOffer.js
  */
function fetchClientApplicationOffer(amount, term, productNumber) {
  return function (_ref12) {
    var httpGet = _ref12.httpGet;
    return {
      type: 'FETCH_CLIENT_APPLICATION_OFFER',
      meta: {
        amount: amount,
        term: term,
        productNumber: productNumber
      },
      payload: {
        promise: httpGet('/client/application/offer', {
          amount: amount,
          term: term,
          productNumber: productNumber
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientApplicationOffer(amount, term, productNumber)
  */
function fetchClientApplicationOfferReset(amount, term, productNumber) {
  var hard = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
  return {
    type: 'FETCH_CLIENT_APPLICATION_OFFER_RESET',
    meta: {
      amount: amount,
      term: term,
      productNumber: productNumber
    },
    hardReset: hard
  };
} /**
  * GET /client/application/offer/extra-service-fee
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     extraServiceFee: ['api', 'fetch', 'client', 'application', 'offer', 'extraServiceFee']
  *   },
  *   actions: {
  *     fetchClientApplicationOfferExtraServiceFee: ['api', 'fetchClientApplicationOfferExtraServiceFee']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [amount, extraServiceRequired, term]
  * so in component you can get to query result by:
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'data'])    #=> Immutable.Map
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'fetched']) #=> boolean
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'pending']) #=> boolean
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).data       #=> Immutable.Map
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).fetched    #=> boolean
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).pending    #=> boolean
  * this.props.extraServiceFee.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).error      #=> null or something returned from action
  *
  * @method fetchClientApplicationOfferExtraServiceFee
  *
  * @param  amount                {Int}
  * @param  extraServiceRequired  {Boolean}
  * @param  term                  {Int}
  *
  * @return {fetchClientApplicationOfferExtraServiceFee} src/common/api/response/fetchClientApplicationOfferExtraServiceFee.js
  */
function fetchClientApplicationOfferExtraServiceFee(amount, extraServiceRequired, term) {
  return function (_ref13) {
    var httpGet = _ref13.httpGet;
    return {
      type: 'FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE',
      meta: {
        amount: amount,
        extraServiceRequired: extraServiceRequired,
        term: term
      },
      payload: {
        promise: httpGet('/client/application/offer/extra-service-fee', {
          amount: amount,
          extraServiceRequired: extraServiceRequired,
          term: term
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientApplicationOfferExtraServiceFee(amount, extraServiceRequired, term)
  */
function fetchClientApplicationOfferExtraServiceFeeReset(amount, extraServiceRequired, term) {
  var hard = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
  return {
    type: 'FETCH_CLIENT_APPLICATION_OFFER_EXTRA_SERVICE_FEE_RESET',
    meta: {
      amount: amount,
      extraServiceRequired: extraServiceRequired,
      term: term
    },
    hardReset: hard
  };
} /**
  * GET /client/application/proposals
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     proposals: ['api', 'fetch', 'client', 'application', 'proposals', 'query']
  *   },
  *   actions: {
  *     fetchClientApplicationProposals: ['api', 'fetchClientApplicationProposals']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.proposals.data    #=> Immutable.Map
  * this.props.proposals.fetched #=> boolean
  * this.props.proposals.pending #=> boolean
  * this.props.proposals.error   #=> null or something returned from action
  *
  * @method fetchClientApplicationProposals
  *
  * @return {fetchClientApplicationProposals} src/common/api/response/fetchClientApplicationProposals.js
  */
function fetchClientApplicationProposals() {
  return function (_ref14) {
    var httpGet = _ref14.httpGet;
    return {
      type: 'FETCH_CLIENT_APPLICATION_PROPOSALS',
      payload: {
        promise: httpGet('/client/application/proposals')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientApplicationProposals()
  */
function fetchClientApplicationProposalsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_APPLICATION_PROPOSALS_RESET',
    hardReset: hard
  };
} /**
  * GET /client/bank-account-number
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     bankAccountNumber: ['api', 'fetch', 'client', 'bankAccountNumber', 'query']
  *   },
  *   actions: {
  *     fetchClientBankAccountNumber: ['api', 'fetchClientBankAccountNumber']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.bankAccountNumber.data    #=> Immutable.Map
  * this.props.bankAccountNumber.fetched #=> boolean
  * this.props.bankAccountNumber.pending #=> boolean
  * this.props.bankAccountNumber.error   #=> null or something returned from action
  *
  * @method fetchClientBankAccountNumber
  *
  * @return {fetchClientBankAccountNumber} src/common/api/response/fetchClientBankAccountNumber.js
  */
function fetchClientBankAccountNumber() {
  return function (_ref15) {
    var httpGet = _ref15.httpGet;
    return {
      type: 'FETCH_CLIENT_BANK_ACCOUNT_NUMBER',
      payload: {
        promise: httpGet('/client/bank-account-number')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientBankAccountNumber()
  */
function fetchClientBankAccountNumberReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET',
    hardReset: hard
  };
} /**
  * GET /client/banks
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     banks: ['api', 'fetch', 'client', 'banks', 'query']
  *   },
  *   actions: {
  *     fetchClientBanks: ['api', 'fetchClientBanks']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.banks.data    #=> Immutable.Map
  * this.props.banks.fetched #=> boolean
  * this.props.banks.pending #=> boolean
  * this.props.banks.error   #=> null or something returned from action
  *
  * @method fetchClientBanks
  *
  * @return {fetchClientBanks} src/common/api/response/fetchClientBanks.js
  */
function fetchClientBanks() {
  return function (_ref16) {
    var httpGet = _ref16.httpGet;
    return {
      type: 'FETCH_CLIENT_BANKS',
      payload: {
        promise: httpGet('/client/banks')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientBanks()
  */
function fetchClientBanksReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_BANKS_RESET',
    hardReset: hard
  };
} /**
  * GET /client/check
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     check: ['api', 'fetch', 'client', 'check']
  *   },
  *   actions: {
  *     fetchClientCheck: ['api', 'fetchClientCheck']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [affiliateProvider, email, mobilePhone, personalId]
  * so in component you can get to query result by:
  * this.props.check.getIn([affiliateProvider.toString(), email.toString(), mobilePhone.toString(), personalId.toString(), 'data'])    #=> Immutable.Map
  * this.props.check.getIn([affiliateProvider.toString(), email.toString(), mobilePhone.toString(), personalId.toString(), 'fetched']) #=> boolean
  * this.props.check.getIn([affiliateProvider.toString(), email.toString(), mobilePhone.toString(), personalId.toString(), 'pending']) #=> boolean
  * this.props.check.getIn([affiliateProvider.toString(), email.toString(), mobilePhone.toString(), personalId.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.check.getIn([affiliateProvider.toString(), email.toString(), mobilePhone.toString(), personalId.toString()]).data       #=> Immutable.Map
  * this.props.check.getIn([affiliateProvider.toString(), email.toString(), mobilePhone.toString(), personalId.toString()]).fetched    #=> boolean
  * this.props.check.getIn([affiliateProvider.toString(), email.toString(), mobilePhone.toString(), personalId.toString()]).pending    #=> boolean
  * this.props.check.getIn([affiliateProvider.toString(), email.toString(), mobilePhone.toString(), personalId.toString()]).error      #=> null or something returned from action
  *
  * @method fetchClientCheck
  *
  * @param  affiliateProvider  {String}
  * @param  email              {String}
  * @param  mobilePhone        {String}
  * @param  personalId         {String}
  *
  */
function fetchClientCheck(affiliateProvider, email, mobilePhone, personalId) {
  return function (_ref17) {
    var httpGet = _ref17.httpGet;
    return {
      type: 'FETCH_CLIENT_CHECK',
      meta: {
        affiliateProvider: affiliateProvider,
        email: email,
        mobilePhone: mobilePhone,
        personalId: personalId
      },
      payload: {
        promise: httpGet('/client/check', {
          affiliateProvider: affiliateProvider,
          email: email,
          mobilePhone: mobilePhone,
          personalId: personalId
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientCheck(affiliateProvider, email, mobilePhone, personalId)
  */
function fetchClientCheckReset(affiliateProvider, email, mobilePhone, personalId) {
  var hard = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];
  return {
    type: 'FETCH_CLIENT_CHECK_RESET',
    meta: {
      affiliateProvider: affiliateProvider,
      email: email,
      mobilePhone: mobilePhone,
      personalId: personalId
    },
    hardReset: hard
  };
} /**
  * GET /client/consents
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     consents: ['api', 'fetch', 'client', 'consents', 'query']
  *   },
  *   actions: {
  *     fetchClientConsents: ['api', 'fetchClientConsents']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.consents.data    #=> Immutable.Map
  * this.props.consents.fetched #=> boolean
  * this.props.consents.pending #=> boolean
  * this.props.consents.error   #=> null or something returned from action
  *
  * @method fetchClientConsents
  *
  * @return {fetchClientConsents} src/common/api/response/fetchClientConsents.js
  */
function fetchClientConsents() {
  return function (_ref18) {
    var httpGet = _ref18.httpGet;
    return {
      type: 'FETCH_CLIENT_CONSENTS',
      payload: {
        promise: httpGet('/client/consents')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientConsents()
  */
function fetchClientConsentsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_CONSENTS_RESET',
    hardReset: hard
  };
} /**
  * GET /client/discounts
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     discounts: ['api', 'fetch', 'client', 'discounts', 'query']
  *   },
  *   actions: {
  *     fetchClientDiscounts: ['api', 'fetchClientDiscounts']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.discounts.data    #=> Immutable.Map
  * this.props.discounts.fetched #=> boolean
  * this.props.discounts.pending #=> boolean
  * this.props.discounts.error   #=> null or something returned from action
  *
  * @method fetchClientDiscounts
  *
  * @return {fetchClientDiscounts} src/common/api/response/fetchClientDiscounts.js
  */
function fetchClientDiscounts() {
  return function (_ref19) {
    var httpGet = _ref19.httpGet;
    return {
      type: 'FETCH_CLIENT_DISCOUNTS',
      payload: {
        promise: httpGet('/client/discounts')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientDiscounts()
  */
function fetchClientDiscountsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_DISCOUNTS_RESET',
    hardReset: hard
  };
} /**
  * GET /client/discounts/available
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     available: ['api', 'fetch', 'client', 'discounts', 'available', 'query']
  *   },
  *   actions: {
  *     fetchClientDiscountsAvailable: ['api', 'fetchClientDiscountsAvailable']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.available.data    #=> Immutable.Map
  * this.props.available.fetched #=> boolean
  * this.props.available.pending #=> boolean
  * this.props.available.error   #=> null or something returned from action
  *
  * @method fetchClientDiscountsAvailable
  *
  * @return {fetchClientDiscountsAvailable} src/common/api/response/fetchClientDiscountsAvailable.js
  */
function fetchClientDiscountsAvailable() {
  return function (_ref20) {
    var httpGet = _ref20.httpGet;
    return {
      type: 'FETCH_CLIENT_DISCOUNTS_AVAILABLE',
      payload: {
        promise: httpGet('/client/discounts/available')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientDiscountsAvailable()
  */
function fetchClientDiscountsAvailableReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_DISCOUNTS_AVAILABLE_RESET',
    hardReset: hard
  };
} /**
  * GET /client/email
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     email: ['api', 'fetch', 'client', 'email', 'query']
  *   },
  *   actions: {
  *     fetchClientEmail: ['api', 'fetchClientEmail']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.email.data    #=> Immutable.Map
  * this.props.email.fetched #=> boolean
  * this.props.email.pending #=> boolean
  * this.props.email.error   #=> null or something returned from action
  *
  * @method fetchClientEmail
  *
  * @return {fetchClientEmail} src/common/api/response/fetchClientEmail.js
  */
function fetchClientEmail() {
  return function (_ref21) {
    var httpGet = _ref21.httpGet;
    return {
      type: 'FETCH_CLIENT_EMAIL',
      payload: {
        promise: httpGet('/client/email')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientEmail()
  */
function fetchClientEmailReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_EMAIL_RESET',
    hardReset: hard
  };
} /**
  * GET /client/email/rate-limit-status
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     rateLimitStatus: ['api', 'fetch', 'client', 'email', 'rateLimitStatus', 'query']
  *   },
  *   actions: {
  *     fetchClientEmailRateLimitStatus: ['api', 'fetchClientEmailRateLimitStatus']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.rateLimitStatus.data    #=> Immutable.Map
  * this.props.rateLimitStatus.fetched #=> boolean
  * this.props.rateLimitStatus.pending #=> boolean
  * this.props.rateLimitStatus.error   #=> null or something returned from action
  *
  * @method fetchClientEmailRateLimitStatus
  *
  */
function fetchClientEmailRateLimitStatus() {
  return function (_ref22) {
    var httpGet = _ref22.httpGet;
    return {
      type: 'FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS',
      payload: {
        promise: httpGet('/client/email/rate-limit-status')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientEmailRateLimitStatus()
  */
function fetchClientEmailRateLimitStatusReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_EMAIL_RATE_LIMIT_STATUS_RESET',
    hardReset: hard
  };
} /**
  * GET /client/employer
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     employer: ['api', 'fetch', 'client', 'employer', 'query']
  *   },
  *   actions: {
  *     fetchClientEmployer: ['api', 'fetchClientEmployer']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.employer.data    #=> Immutable.Map
  * this.props.employer.fetched #=> boolean
  * this.props.employer.pending #=> boolean
  * this.props.employer.error   #=> null or something returned from action
  *
  * @method fetchClientEmployer
  *
  * @return {fetchClientEmployer} src/common/api/response/fetchClientEmployer.js
  */
function fetchClientEmployer() {
  return function (_ref23) {
    var httpGet = _ref23.httpGet;
    return {
      type: 'FETCH_CLIENT_EMPLOYER',
      payload: {
        promise: httpGet('/client/employer')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientEmployer()
  */
function fetchClientEmployerReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_EMPLOYER_RESET',
    hardReset: hard
  };
} /**
  * GET /client/general-terms
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     generalTerms: ['api', 'fetch', 'client', 'generalTerms']
  *   },
  *   actions: {
  *     fetchClientGeneralTerms: ['api', 'fetchClientGeneralTerms']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [inline]
  * so in component you can get to query result by:
  * this.props.generalTerms.getIn([inline.toString(), 'data'])    #=> Immutable.Map
  * this.props.generalTerms.getIn([inline.toString(), 'fetched']) #=> boolean
  * this.props.generalTerms.getIn([inline.toString(), 'pending']) #=> boolean
  * this.props.generalTerms.getIn([inline.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.generalTerms.getIn([inline.toString()]).data       #=> Immutable.Map
  * this.props.generalTerms.getIn([inline.toString()]).fetched    #=> boolean
  * this.props.generalTerms.getIn([inline.toString()]).pending    #=> boolean
  * this.props.generalTerms.getIn([inline.toString()]).error      #=> null or something returned from action
  *
  * @method fetchClientGeneralTerms
  *
  * @param  inline  {Boolean}
  *
  */
function fetchClientGeneralTerms(inline) {
  return function (_ref24) {
    var httpGet = _ref24.httpGet;
    return {
      type: 'FETCH_CLIENT_GENERAL_TERMS',
      meta: {
        inline: inline
      },
      payload: {
        promise: httpGet('/client/general-terms', {
          inline: inline
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientGeneralTerms(inline)
  */
function fetchClientGeneralTermsReset(inline) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'FETCH_CLIENT_GENERAL_TERMS_RESET',
    meta: {
      inline: inline
    },
    hardReset: hard
  };
} /**
  * GET /client/identity-document/photo/{id}
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     photo: ['api', 'fetch', 'client', 'identityDocument', 'photo']
  *   },
  *   actions: {
  *     fetchClientIdentityDocumentPhotoById: ['api', 'fetchClientIdentityDocumentPhotoById']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [id]
  * so in component you can get to query result by:
  * this.props.photo.getIn([id.toString(), 'data'])    #=> Immutable.Map
  * this.props.photo.getIn([id.toString(), 'fetched']) #=> boolean
  * this.props.photo.getIn([id.toString(), 'pending']) #=> boolean
  * this.props.photo.getIn([id.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.photo.getIn([id.toString()]).data       #=> Immutable.Map
  * this.props.photo.getIn([id.toString()]).fetched    #=> boolean
  * this.props.photo.getIn([id.toString()]).pending    #=> boolean
  * this.props.photo.getIn([id.toString()]).error      #=> null or something returned from action
  *
  * @method fetchClientIdentityDocumentPhotoById
  *
  * @param  id  {?}
  *
  */
function fetchClientIdentityDocumentPhotoById(id) {
  return function (_ref25) {
    var httpGet = _ref25.httpGet;
    return {
      type: 'FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID',
      meta: {
        id: id
      },
      payload: {
        promise: httpGet('/client/identity-document/photo/' + id)
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientIdentityDocumentPhotoById(id)
  */
function fetchClientIdentityDocumentPhotoByIdReset(id) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTO_BY_ID_RESET',
    meta: {
      id: id
    },
    hardReset: hard
  };
} /**
  * GET /client/identity-document/photos
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     photos: ['api', 'fetch', 'client', 'identityDocument', 'photos']
  *   },
  *   actions: {
  *     fetchClientIdentityDocumentPhotos: ['api', 'fetchClientIdentityDocumentPhotos']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [type]
  * so in component you can get to query result by:
  * this.props.photos.getIn([type.toString(), 'data'])    #=> Immutable.Map
  * this.props.photos.getIn([type.toString(), 'fetched']) #=> boolean
  * this.props.photos.getIn([type.toString(), 'pending']) #=> boolean
  * this.props.photos.getIn([type.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.photos.getIn([type.toString()]).data       #=> Immutable.Map
  * this.props.photos.getIn([type.toString()]).fetched    #=> boolean
  * this.props.photos.getIn([type.toString()]).pending    #=> boolean
  * this.props.photos.getIn([type.toString()]).error      #=> null or something returned from action
  *
  * @method fetchClientIdentityDocumentPhotos
  *
  * @param  type  {String}
  *
  * @return {fetchClientIdentityDocumentPhotos} src/common/api/response/fetchClientIdentityDocumentPhotos.js
  */
function fetchClientIdentityDocumentPhotos(type) {
  return function (_ref26) {
    var httpGet = _ref26.httpGet;
    return {
      type: 'FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS',
      meta: {
        type: type
      },
      payload: {
        promise: httpGet('/client/identity-document/photos', {
          type: type
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientIdentityDocumentPhotos(type)
  */
function fetchClientIdentityDocumentPhotosReset(type) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'FETCH_CLIENT_IDENTITY_DOCUMENT_PHOTOS_RESET',
    meta: {
      type: type
    },
    hardReset: hard
  };
} /**
  * GET /client/legal-terms
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     legalTerms: ['api', 'fetch', 'client', 'legalTerms']
  *   },
  *   actions: {
  *     fetchClientLegalTerms: ['api', 'fetchClientLegalTerms']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [amount, attachment, extraServiceRequired, term]
  * so in component you can get to query result by:
  * this.props.legalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), term.toString(), 'data'])    #=> Immutable.Map
  * this.props.legalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), term.toString(), 'fetched']) #=> boolean
  * this.props.legalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), term.toString(), 'pending']) #=> boolean
  * this.props.legalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), term.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.legalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), term.toString()]).data       #=> Immutable.Map
  * this.props.legalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), term.toString()]).fetched    #=> boolean
  * this.props.legalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), term.toString()]).pending    #=> boolean
  * this.props.legalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), term.toString()]).error      #=> null or something returned from action
  *
  * @method fetchClientLegalTerms
  *
  * @param  amount                {String}
  * @param  attachment            {Boolean}
  * @param  extraServiceRequired  {Boolean}
  * @param  term                  {Int}
  *
  */
function fetchClientLegalTerms(amount, attachment, extraServiceRequired, term) {
  return function (_ref27) {
    var httpGet = _ref27.httpGet;
    return {
      type: 'FETCH_CLIENT_LEGAL_TERMS',
      meta: {
        amount: amount,
        attachment: attachment,
        extraServiceRequired: extraServiceRequired,
        term: term
      },
      payload: {
        promise: httpGet('/client/legal-terms', {
          amount: amount,
          attachment: attachment,
          extraServiceRequired: extraServiceRequired,
          term: term
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientLegalTerms(amount, attachment, extraServiceRequired, term)
  */
function fetchClientLegalTermsReset(amount, attachment, extraServiceRequired, term) {
  var hard = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];
  return {
    type: 'FETCH_CLIENT_LEGAL_TERMS_RESET',
    meta: {
      amount: amount,
      attachment: attachment,
      extraServiceRequired: extraServiceRequired,
      term: term
    },
    hardReset: hard
  };
} /**
  * GET /client/loans
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     loans: ['api', 'fetch', 'client', 'loans', 'query']
  *   },
  *   actions: {
  *     fetchClientLoans: ['api', 'fetchClientLoans']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.loans.data    #=> Immutable.Map
  * this.props.loans.fetched #=> boolean
  * this.props.loans.pending #=> boolean
  * this.props.loans.error   #=> null or something returned from action
  *
  * @method fetchClientLoans
  *
  * @return {fetchClientLoans} src/common/api/response/fetchClientLoans.js
  */
function fetchClientLoans() {
  return function (_ref28) {
    var httpGet = _ref28.httpGet;
    return {
      type: 'FETCH_CLIENT_LOANS',
      payload: {
        promise: httpGet('/client/loans')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientLoans()
  */
function fetchClientLoansReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_LOANS_RESET',
    hardReset: hard
  };
} /**
  * GET /client/loans/{loanId: \d+|latest|latest\-all\-statuses}
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     loans: ['api', 'fetch', 'client', 'loans']
  *   },
  *   actions: {
  *     fetchClientLoansByLoanid: ['api', 'fetchClientLoansByLoanid']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [loanId]
  * so in component you can get to query result by:
  * this.props.loans.getIn([loanId.toString(), 'data'])    #=> Immutable.Map
  * this.props.loans.getIn([loanId.toString(), 'fetched']) #=> boolean
  * this.props.loans.getIn([loanId.toString(), 'pending']) #=> boolean
  * this.props.loans.getIn([loanId.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.loans.getIn([loanId.toString()]).data       #=> Immutable.Map
  * this.props.loans.getIn([loanId.toString()]).fetched    #=> boolean
  * this.props.loans.getIn([loanId.toString()]).pending    #=> boolean
  * this.props.loans.getIn([loanId.toString()]).error      #=> null or something returned from action
  *
  * @method fetchClientLoansByLoanid
  *
  * @param  loanId  {?}
  *
  * @return {fetchClientLoansByLoanid} src/common/api/response/fetchClientLoansByLoanid.js
  */
function fetchClientLoansByLoanid(loanId) {
  return function (_ref29) {
    var httpGet = _ref29.httpGet;
    return {
      type: 'FETCH_CLIENT_LOANS_BY_LOANID',
      meta: {
        loanId: loanId
      },
      payload: {
        promise: httpGet('/client/loans/' + loanId)
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientLoansByLoanid(loanId)
  */
function fetchClientLoansByLoanidReset(loanId) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'FETCH_CLIENT_LOANS_BY_LOANID_RESET',
    meta: {
      loanId: loanId
    },
    hardReset: hard
  };
} /**
  * GET /client/loans/{loanId: \d+|latest|latest\-all\-statuses}/debt-payment-schedule
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     debtPaymentSchedule: ['api', 'fetch', 'client', 'loans', 'debtPaymentSchedule']
  *   },
  *   actions: {
  *     fetchClientLoansDebtPaymentScheduleByLoanid: ['api', 'fetchClientLoansDebtPaymentScheduleByLoanid']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [loanId]
  * so in component you can get to query result by:
  * this.props.debtPaymentSchedule.getIn([loanId.toString(), 'data'])    #=> Immutable.Map
  * this.props.debtPaymentSchedule.getIn([loanId.toString(), 'fetched']) #=> boolean
  * this.props.debtPaymentSchedule.getIn([loanId.toString(), 'pending']) #=> boolean
  * this.props.debtPaymentSchedule.getIn([loanId.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.debtPaymentSchedule.getIn([loanId.toString()]).data       #=> Immutable.Map
  * this.props.debtPaymentSchedule.getIn([loanId.toString()]).fetched    #=> boolean
  * this.props.debtPaymentSchedule.getIn([loanId.toString()]).pending    #=> boolean
  * this.props.debtPaymentSchedule.getIn([loanId.toString()]).error      #=> null or something returned from action
  *
  * @method fetchClientLoansDebtPaymentScheduleByLoanid
  *
  * @param  loanId  {?}
  *
  * @return {fetchClientLoansDebtPaymentScheduleByLoanid} src/common/api/response/fetchClientLoansDebtPaymentScheduleByLoanid.js
  */
function fetchClientLoansDebtPaymentScheduleByLoanid(loanId) {
  return function (_ref30) {
    var httpGet = _ref30.httpGet;
    return {
      type: 'FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID',
      meta: {
        loanId: loanId
      },
      payload: {
        promise: httpGet('/client/loans/' + loanId + '/debt-payment-schedule')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientLoansDebtPaymentScheduleByLoanid(loanId)
  */
function fetchClientLoansDebtPaymentScheduleByLoanidReset(loanId) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'FETCH_CLIENT_LOANS_DEBT_PAYMENT_SCHEDULE_BY_LOANID_RESET',
    meta: {
      loanId: loanId
    },
    hardReset: hard
  };
} /**
  * GET /client/missing-mandatory-fields
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     missingMandatoryFields: ['api', 'fetch', 'client', 'missingMandatoryFields', 'query']
  *   },
  *   actions: {
  *     fetchClientMissingMandatoryFields: ['api', 'fetchClientMissingMandatoryFields']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.missingMandatoryFields.data    #=> Immutable.Map
  * this.props.missingMandatoryFields.fetched #=> boolean
  * this.props.missingMandatoryFields.pending #=> boolean
  * this.props.missingMandatoryFields.error   #=> null or something returned from action
  *
  * @method fetchClientMissingMandatoryFields
  *
  * @return {fetchClientMissingMandatoryFields} src/common/api/response/fetchClientMissingMandatoryFields.js
  */
function fetchClientMissingMandatoryFields() {
  return function (_ref31) {
    var httpGet = _ref31.httpGet;
    return {
      type: 'FETCH_CLIENT_MISSING_MANDATORY_FIELDS',
      payload: {
        promise: httpGet('/client/missing-mandatory-fields')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientMissingMandatoryFields()
  */
function fetchClientMissingMandatoryFieldsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_MISSING_MANDATORY_FIELDS_RESET',
    hardReset: hard
  };
} /**
  * GET /client/password/recovery/phone/{phoneNumber}
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     phone: ['api', 'fetch', 'client', 'password', 'recovery', 'phone']
  *   },
  *   actions: {
  *     fetchClientPasswordRecoveryPhoneByPhonenumber: ['api', 'fetchClientPasswordRecoveryPhoneByPhonenumber']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [responseToken, phoneNumber]
  * so in component you can get to query result by:
  * this.props.phone.getIn([responseToken.toString(), phoneNumber.toString(), 'data'])    #=> Immutable.Map
  * this.props.phone.getIn([responseToken.toString(), phoneNumber.toString(), 'fetched']) #=> boolean
  * this.props.phone.getIn([responseToken.toString(), phoneNumber.toString(), 'pending']) #=> boolean
  * this.props.phone.getIn([responseToken.toString(), phoneNumber.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.phone.getIn([responseToken.toString(), phoneNumber.toString()]).data       #=> Immutable.Map
  * this.props.phone.getIn([responseToken.toString(), phoneNumber.toString()]).fetched    #=> boolean
  * this.props.phone.getIn([responseToken.toString(), phoneNumber.toString()]).pending    #=> boolean
  * this.props.phone.getIn([responseToken.toString(), phoneNumber.toString()]).error      #=> null or something returned from action
  *
  * @method fetchClientPasswordRecoveryPhoneByPhonenumber
  *
  * @param  responseToken  {String}
  * @param  phoneNumber    {?}
  *
  * @return {fetchClientPasswordRecoveryPhoneByPhonenumber} src/common/api/response/fetchClientPasswordRecoveryPhoneByPhonenumber.js
  */
function fetchClientPasswordRecoveryPhoneByPhonenumber(responseToken, phoneNumber) {
  return function (_ref32) {
    var httpGet = _ref32.httpGet;
    return {
      type: 'FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER',
      meta: {
        responseToken: responseToken,
        phoneNumber: phoneNumber
      },
      payload: {
        promise: httpGet('/client/password/recovery/phone/' + phoneNumber, {
          responseToken: responseToken
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientPasswordRecoveryPhoneByPhonenumber(responseToken, phoneNumber)
  */
function fetchClientPasswordRecoveryPhoneByPhonenumberReset(responseToken, phoneNumber) {
  var hard = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
  return {
    type: 'FETCH_CLIENT_PASSWORD_RECOVERY_PHONE_BY_PHONENUMBER_RESET',
    meta: {
      responseToken: responseToken,
      phoneNumber: phoneNumber
    },
    hardReset: hard
  };
} /**
  * GET /client/phone
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     phone: ['api', 'fetch', 'client', 'phone', 'query']
  *   },
  *   actions: {
  *     fetchClientPhone: ['api', 'fetchClientPhone']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.phone.data    #=> Immutable.Map
  * this.props.phone.fetched #=> boolean
  * this.props.phone.pending #=> boolean
  * this.props.phone.error   #=> null or something returned from action
  *
  * @method fetchClientPhone
  *
  * @return {fetchClientPhone} src/common/api/response/fetchClientPhone.js
  */
function fetchClientPhone() {
  return function (_ref33) {
    var httpGet = _ref33.httpGet;
    return {
      type: 'FETCH_CLIENT_PHONE',
      payload: {
        promise: httpGet('/client/phone')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientPhone()
  */
function fetchClientPhoneReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_PHONE_RESET',
    hardReset: hard
  };
} /**
  * GET /client/phone/rate-limit-status
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     rateLimitStatus: ['api', 'fetch', 'client', 'phone', 'rateLimitStatus', 'query']
  *   },
  *   actions: {
  *     fetchClientPhoneRateLimitStatus: ['api', 'fetchClientPhoneRateLimitStatus']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.rateLimitStatus.data    #=> Immutable.Map
  * this.props.rateLimitStatus.fetched #=> boolean
  * this.props.rateLimitStatus.pending #=> boolean
  * this.props.rateLimitStatus.error   #=> null or something returned from action
  *
  * @method fetchClientPhoneRateLimitStatus
  *
  */
function fetchClientPhoneRateLimitStatus() {
  return function (_ref34) {
    var httpGet = _ref34.httpGet;
    return {
      type: 'FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS',
      payload: {
        promise: httpGet('/client/phone/rate-limit-status')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientPhoneRateLimitStatus()
  */
function fetchClientPhoneRateLimitStatusReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_PHONE_RATE_LIMIT_STATUS_RESET',
    hardReset: hard
  };
} /**
  * GET /client/settings
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     settings: ['api', 'fetch', 'client', 'settings', 'query']
  *   },
  *   actions: {
  *     fetchClientSettings: ['api', 'fetchClientSettings']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.settings.data    #=> Immutable.Map
  * this.props.settings.fetched #=> boolean
  * this.props.settings.pending #=> boolean
  * this.props.settings.error   #=> null or something returned from action
  *
  * @method fetchClientSettings
  *
  * @return {fetchClientSettings} src/common/api/response/fetchClientSettings.js
  */
function fetchClientSettings() {
  return function (_ref35) {
    var httpGet = _ref35.httpGet;
    return {
      type: 'FETCH_CLIENT_SETTINGS',
      payload: {
        promise: httpGet('/client/settings')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchClientSettings()
  */
function fetchClientSettingsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_CLIENT_SETTINGS_RESET',
    hardReset: hard
  };
} /**
  * GET /dictionary/countries
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     countries: ['api', 'fetch', 'dictionary', 'countries', 'query']
  *   },
  *   actions: {
  *     fetchDictionaryCountries: ['api', 'fetchDictionaryCountries']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.countries.data    #=> Immutable.Map
  * this.props.countries.fetched #=> boolean
  * this.props.countries.pending #=> boolean
  * this.props.countries.error   #=> null or something returned from action
  *
  * @method fetchDictionaryCountries
  *
  * @return {fetchDictionaryCountries} src/common/api/response/fetchDictionaryCountries.js
  */
function fetchDictionaryCountries() {
  return function (_ref36) {
    var httpGet = _ref36.httpGet;
    return {
      type: 'FETCH_DICTIONARY_COUNTRIES',
      payload: {
        promise: httpGet('/dictionary/countries')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchDictionaryCountries()
  */
function fetchDictionaryCountriesReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_DICTIONARY_COUNTRIES_RESET',
    hardReset: hard
  };
} /**
  * GET /employment/professions
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     professions: ['api', 'fetch', 'employment', 'professions', 'query']
  *   },
  *   actions: {
  *     fetchEmploymentProfessions: ['api', 'fetchEmploymentProfessions']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.professions.data    #=> Immutable.Map
  * this.props.professions.fetched #=> boolean
  * this.props.professions.pending #=> boolean
  * this.props.professions.error   #=> null or something returned from action
  *
  * @method fetchEmploymentProfessions
  *
  * @return {fetchEmploymentProfessions} src/common/api/response/fetchEmploymentProfessions.js
  */
function fetchEmploymentProfessions() {
  return function (_ref37) {
    var httpGet = _ref37.httpGet;
    return {
      type: 'FETCH_EMPLOYMENT_PROFESSIONS',
      payload: {
        promise: httpGet('/employment/professions')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchEmploymentProfessions()
  */
function fetchEmploymentProfessionsReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_EMPLOYMENT_PROFESSIONS_RESET',
    hardReset: hard
  };
} /**
  * GET /first-loan-legal-terms
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     firstLoanLegalTerms: ['api', 'fetch', 'firstLoanLegalTerms']
  *   },
  *   actions: {
  *     fetchFirstLoanLegalTerms: ['api', 'fetchFirstLoanLegalTerms']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [amount, attachment, extraServiceRequired, productNumber, term]
  * so in component you can get to query result by:
  * this.props.firstLoanLegalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), productNumber.toString(), term.toString(), 'data'])    #=> Immutable.Map
  * this.props.firstLoanLegalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), productNumber.toString(), term.toString(), 'fetched']) #=> boolean
  * this.props.firstLoanLegalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), productNumber.toString(), term.toString(), 'pending']) #=> boolean
  * this.props.firstLoanLegalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), productNumber.toString(), term.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.firstLoanLegalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), productNumber.toString(), term.toString()]).data       #=> Immutable.Map
  * this.props.firstLoanLegalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), productNumber.toString(), term.toString()]).fetched    #=> boolean
  * this.props.firstLoanLegalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), productNumber.toString(), term.toString()]).pending    #=> boolean
  * this.props.firstLoanLegalTerms.getIn([amount.toString(), attachment.toString(), extraServiceRequired.toString(), productNumber.toString(), term.toString()]).error      #=> null or something returned from action
  *
  * @method fetchFirstLoanLegalTerms
  *
  * @param  amount                {String}
  * @param  attachment            {Boolean}
  * @param  extraServiceRequired  {Boolean}
  * @param  productNumber         {String}
  * @param  term                  {Int}
  *
  */
function fetchFirstLoanLegalTerms(amount, attachment, extraServiceRequired, productNumber, term) {
  return function (_ref38) {
    var httpGet = _ref38.httpGet;
    return {
      type: 'FETCH_FIRST_LOAN_LEGAL_TERMS',
      meta: {
        amount: amount,
        attachment: attachment,
        extraServiceRequired: extraServiceRequired,
        productNumber: productNumber,
        term: term
      },
      payload: {
        promise: httpGet('/first-loan-legal-terms', {
          amount: amount,
          attachment: attachment,
          extraServiceRequired: extraServiceRequired,
          productNumber: productNumber,
          term: term
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchFirstLoanLegalTerms(amount, attachment, extraServiceRequired, productNumber, term)
  */
function fetchFirstLoanLegalTermsReset(amount, attachment, extraServiceRequired, productNumber, term) {
  var hard = arguments.length <= 5 || arguments[5] === undefined ? false : arguments[5];
  return {
    type: 'FETCH_FIRST_LOAN_LEGAL_TERMS_RESET',
    meta: {
      amount: amount,
      attachment: attachment,
      extraServiceRequired: extraServiceRequired,
      productNumber: productNumber,
      term: term
    },
    hardReset: hard
  };
} /**
  * GET /general-terms
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     generalTerms: ['api', 'fetch', 'generalTerms']
  *   },
  *   actions: {
  *     fetchGeneralTerms: ['api', 'fetchGeneralTerms']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [inline]
  * so in component you can get to query result by:
  * this.props.generalTerms.getIn([inline.toString(), 'data'])    #=> Immutable.Map
  * this.props.generalTerms.getIn([inline.toString(), 'fetched']) #=> boolean
  * this.props.generalTerms.getIn([inline.toString(), 'pending']) #=> boolean
  * this.props.generalTerms.getIn([inline.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.generalTerms.getIn([inline.toString()]).data       #=> Immutable.Map
  * this.props.generalTerms.getIn([inline.toString()]).fetched    #=> boolean
  * this.props.generalTerms.getIn([inline.toString()]).pending    #=> boolean
  * this.props.generalTerms.getIn([inline.toString()]).error      #=> null or something returned from action
  *
  * @method fetchGeneralTerms
  *
  * @param  inline  {Boolean}
  *
  */
function fetchGeneralTerms(inline) {
  return function (_ref39) {
    var httpGet = _ref39.httpGet;
    return {
      type: 'FETCH_GENERAL_TERMS',
      meta: {
        inline: inline
      },
      payload: {
        promise: httpGet('/general-terms', {
          inline: inline
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchGeneralTerms(inline)
  */
function fetchGeneralTermsReset(inline) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'FETCH_GENERAL_TERMS_RESET',
    meta: {
      inline: inline
    },
    hardReset: hard
  };
} /**
  * GET /next-loan-legal-terms
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     nextLoanLegalTerms: ['api', 'fetch', 'nextLoanLegalTerms']
  *   },
  *   actions: {
  *     fetchNextLoanLegalTerms: ['api', 'fetchNextLoanLegalTerms']
  *   }
  * })
  *
  * This action returns saves queries to nested structure with [amount, extraServiceRequired, term]
  * so in component you can get to query result by:
  * this.props.nextLoanLegalTerms.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'data'])    #=> Immutable.Map
  * this.props.nextLoanLegalTerms.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'fetched']) #=> boolean
  * this.props.nextLoanLegalTerms.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'pending']) #=> boolean
  * this.props.nextLoanLegalTerms.getIn([amount.toString(), extraServiceRequired.toString(), term.toString(), 'error'])   #=> null or something returned from action
  * or
  * this.props.nextLoanLegalTerms.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).data       #=> Immutable.Map
  * this.props.nextLoanLegalTerms.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).fetched    #=> boolean
  * this.props.nextLoanLegalTerms.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).pending    #=> boolean
  * this.props.nextLoanLegalTerms.getIn([amount.toString(), extraServiceRequired.toString(), term.toString()]).error      #=> null or something returned from action
  *
  * @method fetchNextLoanLegalTerms
  *
  * @param  amount                {String}
  * @param  extraServiceRequired  {Boolean}
  * @param  term                  {Int}
  *
  */
function fetchNextLoanLegalTerms(amount, extraServiceRequired, term) {
  return function (_ref40) {
    var httpGet = _ref40.httpGet;
    return {
      type: 'FETCH_NEXT_LOAN_LEGAL_TERMS',
      meta: {
        amount: amount,
        extraServiceRequired: extraServiceRequired,
        term: term
      },
      payload: {
        promise: httpGet('/next-loan-legal-terms', {
          amount: amount,
          extraServiceRequired: extraServiceRequired,
          term: term
        })
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchNextLoanLegalTerms(amount, extraServiceRequired, term)
  */
function fetchNextLoanLegalTermsReset(amount, extraServiceRequired, term) {
  var hard = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
  return {
    type: 'FETCH_NEXT_LOAN_LEGAL_TERMS_RESET',
    meta: {
      amount: amount,
      extraServiceRequired: extraServiceRequired,
      term: term
    },
    hardReset: hard
  };
} /**
  * GET /registration
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     registration: ['api', 'fetch', 'registration', 'query']
  *   },
  *   actions: {
  *     fetchRegistration: ['api', 'fetchRegistration']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.registration.data    #=> Immutable.Map
  * this.props.registration.fetched #=> boolean
  * this.props.registration.pending #=> boolean
  * this.props.registration.error   #=> null or something returned from action
  *
  * @method fetchRegistration
  *
  * @return {fetchRegistration} src/common/api/response/fetchRegistration.js
  */
function fetchRegistration() {
  return function (_ref41) {
    var httpGet = _ref41.httpGet;
    return {
      type: 'FETCH_REGISTRATION',
      payload: {
        promise: httpGet('/registration')
      }
    };
  };
} /**
  * Reset state to its original state before calling fetchRegistration()
  */
function fetchRegistrationReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'FETCH_REGISTRATION_RESET',
    hardReset: hard
  };
} /**
  * POST /client/application
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     application: ['api', 'send', 'client', 'application', 'query']
  *   },
  *   actions: {
  *     sendClientApplication: ['api', 'sendClientApplication']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.application.data    #=> Immutable.Map
  * this.props.application.fetched #=> boolean
  * this.props.application.pending #=> boolean
  * this.props.application.error   #=> null or something returned from action
  *
  * @method sendClientApplication
  *
  * @param  params  {sendClientApplication}  src/api/request/sendClientApplication.js
  *
  * @return {sendClientApplication} src/common/api/response/sendClientApplication.js
  */
function sendClientApplication(params) {
  return function (_ref42) {
    var httpPost = _ref42.httpPost;
    return {
      type: 'SEND_CLIENT_APPLICATION',
      meta: {
        params: params
      },
      payload: {
        promise: httpPost('/client/application', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling sendClientApplication(params)
  */
function sendClientApplicationReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_CLIENT_APPLICATION_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * POST /client/cookies
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     cookies: ['api', 'send', 'client', 'cookies', 'query']
  *   },
  *   actions: {
  *     sendClientCookies: ['api', 'sendClientCookies']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.cookies.data    #=> Immutable.Map
  * this.props.cookies.fetched #=> boolean
  * this.props.cookies.pending #=> boolean
  * this.props.cookies.error   #=> null or something returned from action
  *
  * @method sendClientCookies
  *
  * @param  params  {sendClientCookies}  src/api/request/sendClientCookies.js
  *
  */
function sendClientCookies(params) {
  return function (_ref43) {
    var httpPost = _ref43.httpPost;
    return {
      type: 'SEND_CLIENT_COOKIES',
      meta: {
        params: params
      },
      payload: {
        promise: httpPost('/client/cookies', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling sendClientCookies(params)
  */
function sendClientCookiesReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_CLIENT_COOKIES_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * POST /client/email
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     email: ['api', 'send', 'client', 'email', 'query']
  *   },
  *   actions: {
  *     sendClientEmail: ['api', 'sendClientEmail']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.email.data    #=> Immutable.Map
  * this.props.email.fetched #=> boolean
  * this.props.email.pending #=> boolean
  * this.props.email.error   #=> null or something returned from action
  *
  * @method sendClientEmail
  *
  * @param  params  {sendClientEmail}  src/api/request/sendClientEmail.js
  *
  * @return {sendClientEmail} src/common/api/response/sendClientEmail.js
  */
function sendClientEmail(params) {
  return function (_ref44) {
    var httpPost = _ref44.httpPost;
    return {
      type: 'SEND_CLIENT_EMAIL',
      meta: {
        params: params
      },
      payload: {
        promise: httpPost('/client/email', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling sendClientEmail(params)
  */
function sendClientEmailReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_CLIENT_EMAIL_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * POST /client/identity-document/upload-photo
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     uploadPhoto: ['api', 'send', 'client', 'identityDocument', 'uploadPhoto', 'query']
  *   },
  *   actions: {
  *     sendClientIdentityDocumentUploadPhoto: ['api', 'sendClientIdentityDocumentUploadPhoto']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.uploadPhoto.data    #=> Immutable.Map
  * this.props.uploadPhoto.fetched #=> boolean
  * this.props.uploadPhoto.pending #=> boolean
  * this.props.uploadPhoto.error   #=> null or something returned from action
  *
  * @method sendClientIdentityDocumentUploadPhoto
  *
  * @param  params  {multipart/form-data}
  *
  */
function sendClientIdentityDocumentUploadPhoto(params) {
  return function (_ref45) {
    var httpPost = _ref45.httpPost;
    return {
      type: 'SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO',
      meta: {
        params: params
      },
      payload: {
        promise: httpPost('/client/identity-document/upload-photo', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling sendClientIdentityDocumentUploadPhoto(params)
  */
function sendClientIdentityDocumentUploadPhotoReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_CLIENT_IDENTITY_DOCUMENT_UPLOAD_PHOTO_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * POST /client/password/recovery/validate-code
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     validateCode: ['api', 'send', 'client', 'password', 'recovery', 'validateCode', 'query']
  *   },
  *   actions: {
  *     sendClientPasswordRecoveryValidateCode: ['api', 'sendClientPasswordRecoveryValidateCode']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.validateCode.data    #=> Immutable.Map
  * this.props.validateCode.fetched #=> boolean
  * this.props.validateCode.pending #=> boolean
  * this.props.validateCode.error   #=> null or something returned from action
  *
  * @method sendClientPasswordRecoveryValidateCode
  *
  * @return {sendClientPasswordRecoveryValidateCode} src/common/api/response/sendClientPasswordRecoveryValidateCode.js
  */
function sendClientPasswordRecoveryValidateCode() {
  return function (_ref46) {
    var httpPost = _ref46.httpPost;
    return {
      type: 'SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE',
      payload: {
        promise: httpPost('/client/password/recovery/validate-code')
      }
    };
  };
} /**
  * Reset state to its original state before calling sendClientPasswordRecoveryValidateCode()
  */
function sendClientPasswordRecoveryValidateCodeReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'SEND_CLIENT_PASSWORD_RECOVERY_VALIDATE_CODE_RESET',
    hardReset: hard
  };
} /**
  * POST /client/phone
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     phone: ['api', 'send', 'client', 'phone', 'query']
  *   },
  *   actions: {
  *     sendClientPhone: ['api', 'sendClientPhone']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.phone.data    #=> Immutable.Map
  * this.props.phone.fetched #=> boolean
  * this.props.phone.pending #=> boolean
  * this.props.phone.error   #=> null or something returned from action
  *
  * @method sendClientPhone
  *
  * @param  params  {sendClientPhone}  src/api/request/sendClientPhone.js
  *
  * @return {sendClientPhone} src/common/api/response/sendClientPhone.js
  */
function sendClientPhone(params) {
  return function (_ref47) {
    var httpPost = _ref47.httpPost;
    return {
      type: 'SEND_CLIENT_PHONE',
      meta: {
        params: params
      },
      payload: {
        promise: httpPost('/client/phone', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling sendClientPhone(params)
  */
function sendClientPhoneReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_CLIENT_PHONE_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * POST /client/temporary-password
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     temporaryPassword: ['api', 'send', 'client', 'temporaryPassword', 'query']
  *   },
  *   actions: {
  *     sendClientTemporaryPassword: ['api', 'sendClientTemporaryPassword']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.temporaryPassword.data    #=> Immutable.Map
  * this.props.temporaryPassword.fetched #=> boolean
  * this.props.temporaryPassword.pending #=> boolean
  * this.props.temporaryPassword.error   #=> null or something returned from action
  *
  * @method sendClientTemporaryPassword
  *
  * @param  params  {sendClientTemporaryPassword}  src/api/request/sendClientTemporaryPassword.js
  *
  */
function sendClientTemporaryPassword(params) {
  return function (_ref48) {
    var httpPost = _ref48.httpPost;
    return {
      type: 'SEND_CLIENT_TEMPORARY_PASSWORD',
      meta: {
        params: params
      },
      payload: {
        promise: httpPost('/client/temporary-password', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling sendClientTemporaryPassword(params)
  */
function sendClientTemporaryPasswordReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_CLIENT_TEMPORARY_PASSWORD_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * POST /registration
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     registration: ['api', 'send', 'registration', 'query']
  *   },
  *   actions: {
  *     sendRegistration: ['api', 'sendRegistration']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.registration.data    #=> Immutable.Map
  * this.props.registration.fetched #=> boolean
  * this.props.registration.pending #=> boolean
  * this.props.registration.error   #=> null or something returned from action
  *
  * @method sendRegistration
  *
  * @param  params  {sendRegistration}  src/api/request/sendRegistration.js
  *
  * @return {sendRegistration} src/common/api/response/sendRegistration.js
  */
function sendRegistration(params) {
  return function (_ref49) {
    var httpPost = _ref49.httpPost;
    return {
      type: 'SEND_REGISTRATION',
      meta: {
        params: params
      },
      payload: {
        promise: httpPost('/registration', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling sendRegistration(params)
  */
function sendRegistrationReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_REGISTRATION_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * POST /token/application
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     application: ['api', 'send', 'token', 'application', 'query']
  *   },
  *   actions: {
  *     sendTokenApplication: ['api', 'sendTokenApplication']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.application.data    #=> Immutable.Map
  * this.props.application.fetched #=> boolean
  * this.props.application.pending #=> boolean
  * this.props.application.error   #=> null or something returned from action
  *
  * @method sendTokenApplication
  *
  * @param  params  {sendTokenApplication}  src/api/request/sendTokenApplication.js
  *
  * @return {sendTokenApplication} src/common/api/response/sendTokenApplication.js
  */
function sendTokenApplication(params) {
  return function (_ref50) {
    var httpPost = _ref50.httpPost;
    return {
      type: 'SEND_TOKEN_APPLICATION',
      meta: {
        params: params
      },
      payload: {
        promise: httpPost('/token/application', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling sendTokenApplication(params)
  */
function sendTokenApplicationReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'SEND_TOKEN_APPLICATION_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * POST /token/basic
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     basic: ['api', 'send', 'token', 'basic', 'query']
  *   },
  *   actions: {
  *     sendTokenBasic: ['api', 'sendTokenBasic']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.basic.data    #=> Immutable.Map
  * this.props.basic.fetched #=> boolean
  * this.props.basic.pending #=> boolean
  * this.props.basic.error   #=> null or something returned from action
  *
  * @method sendTokenBasic
  *
  * @return {sendTokenBasic} src/common/api/response/sendTokenBasic.js
  */
function sendTokenBasic() {
  return function (_ref51) {
    var httpPost = _ref51.httpPost;
    return {
      type: 'SEND_TOKEN_BASIC',
      payload: {
        promise: httpPost('/token/basic')
      }
    };
  };
} /**
  * Reset state to its original state before calling sendTokenBasic()
  */
function sendTokenBasicReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'SEND_TOKEN_BASIC_RESET',
    hardReset: hard
  };
} /**
  * PUT /client/application
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     application: ['api', 'patch', 'client', 'application', 'query']
  *   },
  *   actions: {
  *     patchClientApplication: ['api', 'patchClientApplication']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.application.data    #=> Immutable.Map
  * this.props.application.fetched #=> boolean
  * this.props.application.pending #=> boolean
  * this.props.application.error   #=> null or something returned from action
  *
  * @method patchClientApplication
  *
  * @return {patchClientApplication} src/common/api/response/patchClientApplication.js
  */
function patchClientApplication() {
  return function (_ref52) {
    var httpPut = _ref52.httpPut;
    return {
      type: 'PATCH_CLIENT_APPLICATION',
      payload: {
        promise: httpPut('/client/application')
      }
    };
  };
} /**
  * Reset state to its original state before calling patchClientApplication()
  */
function patchClientApplicationReset() {
  var hard = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
  return {
    type: 'PATCH_CLIENT_APPLICATION_RESET',
    hardReset: hard
  };
} /**
  * PUT /client/bank-account-number
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     bankAccountNumber: ['api', 'patch', 'client', 'bankAccountNumber', 'query']
  *   },
  *   actions: {
  *     patchClientBankAccountNumber: ['api', 'patchClientBankAccountNumber']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.bankAccountNumber.data    #=> Immutable.Map
  * this.props.bankAccountNumber.fetched #=> boolean
  * this.props.bankAccountNumber.pending #=> boolean
  * this.props.bankAccountNumber.error   #=> null or something returned from action
  *
  * @method patchClientBankAccountNumber
  *
  * @param  params  {patchClientBankAccountNumber}  src/api/request/patchClientBankAccountNumber.js
  *
  * @return {patchClientBankAccountNumber} src/common/api/response/patchClientBankAccountNumber.js
  */
function patchClientBankAccountNumber(params) {
  return function (_ref53) {
    var httpPut = _ref53.httpPut;
    return {
      type: 'PATCH_CLIENT_BANK_ACCOUNT_NUMBER',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/bank-account-number', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling patchClientBankAccountNumber(params)
  */
function patchClientBankAccountNumberReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_BANK_ACCOUNT_NUMBER_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * PUT /client/email-confirmation
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     emailConfirmation: ['api', 'patch', 'client', 'emailConfirmation', 'query']
  *   },
  *   actions: {
  *     patchClientEmailConfirmation: ['api', 'patchClientEmailConfirmation']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.emailConfirmation.data    #=> Immutable.Map
  * this.props.emailConfirmation.fetched #=> boolean
  * this.props.emailConfirmation.pending #=> boolean
  * this.props.emailConfirmation.error   #=> null or something returned from action
  *
  * @method patchClientEmailConfirmation
  *
  * @param  params  {patchClientEmailConfirmation}  src/api/request/patchClientEmailConfirmation.js
  *
  * @return {patchClientEmailConfirmation} src/common/api/response/patchClientEmailConfirmation.js
  */
function patchClientEmailConfirmation(params) {
  return function (_ref54) {
    var httpPut = _ref54.httpPut;
    return {
      type: 'PATCH_CLIENT_EMAIL_CONFIRMATION',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/email-confirmation', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling patchClientEmailConfirmation(params)
  */
function patchClientEmailConfirmationReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_EMAIL_CONFIRMATION_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * PUT /client/employer
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     employer: ['api', 'patch', 'client', 'employer', 'query']
  *   },
  *   actions: {
  *     patchClientEmployer: ['api', 'patchClientEmployer']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.employer.data    #=> Immutable.Map
  * this.props.employer.fetched #=> boolean
  * this.props.employer.pending #=> boolean
  * this.props.employer.error   #=> null or something returned from action
  *
  * @method patchClientEmployer
  *
  * @param  params  {patchClientEmployer}  src/api/request/patchClientEmployer.js
  *
  * @return {patchClientEmployer} src/common/api/response/patchClientEmployer.js
  */
function patchClientEmployer(params) {
  return function (_ref55) {
    var httpPut = _ref55.httpPut;
    return {
      type: 'PATCH_CLIENT_EMPLOYER',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/employer', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling patchClientEmployer(params)
  */
function patchClientEmployerReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_EMPLOYER_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * PUT /client/missing-mandatory-fields
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     missingMandatoryFields: ['api', 'patch', 'client', 'missingMandatoryFields', 'query']
  *   },
  *   actions: {
  *     patchClientMissingMandatoryFields: ['api', 'patchClientMissingMandatoryFields']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.missingMandatoryFields.data    #=> Immutable.Map
  * this.props.missingMandatoryFields.fetched #=> boolean
  * this.props.missingMandatoryFields.pending #=> boolean
  * this.props.missingMandatoryFields.error   #=> null or something returned from action
  *
  * @method patchClientMissingMandatoryFields
  *
  * @param  params  {patchClientMissingMandatoryFields}  src/api/request/patchClientMissingMandatoryFields.js
  *
  */
function patchClientMissingMandatoryFields(params) {
  return function (_ref56) {
    var httpPut = _ref56.httpPut;
    return {
      type: 'PATCH_CLIENT_MISSING_MANDATORY_FIELDS',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/missing-mandatory-fields', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling patchClientMissingMandatoryFields(params)
  */
function patchClientMissingMandatoryFieldsReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_MISSING_MANDATORY_FIELDS_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * PUT /client/password
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     password: ['api', 'patch', 'client', 'password', 'query']
  *   },
  *   actions: {
  *     patchClientPassword: ['api', 'patchClientPassword']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.password.data    #=> Immutable.Map
  * this.props.password.fetched #=> boolean
  * this.props.password.pending #=> boolean
  * this.props.password.error   #=> null or something returned from action
  *
  * @method patchClientPassword
  *
  * @param  params  {patchClientPassword}  src/api/request/patchClientPassword.js
  *
  */
function patchClientPassword(params) {
  return function (_ref57) {
    var httpPut = _ref57.httpPut;
    return {
      type: 'PATCH_CLIENT_PASSWORD',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/password', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling patchClientPassword(params)
  */
function patchClientPasswordReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_PASSWORD_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * PUT /client/phone
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     phone: ['api', 'patch', 'client', 'phone', 'query']
  *   },
  *   actions: {
  *     patchClientPhone: ['api', 'patchClientPhone']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.phone.data    #=> Immutable.Map
  * this.props.phone.fetched #=> boolean
  * this.props.phone.pending #=> boolean
  * this.props.phone.error   #=> null or something returned from action
  *
  * @method patchClientPhone
  *
  * @param  params  {patchClientPhone}  src/api/request/patchClientPhone.js
  *
  * @return {patchClientPhone} src/common/api/response/patchClientPhone.js
  */
function patchClientPhone(params) {
  return function (_ref58) {
    var httpPut = _ref58.httpPut;
    return {
      type: 'PATCH_CLIENT_PHONE',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/phone', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling patchClientPhone(params)
  */
function patchClientPhoneReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_PHONE_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * PUT /client/phone-confirmation
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     phoneConfirmation: ['api', 'patch', 'client', 'phoneConfirmation', 'query']
  *   },
  *   actions: {
  *     patchClientPhoneConfirmation: ['api', 'patchClientPhoneConfirmation']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.phoneConfirmation.data    #=> Immutable.Map
  * this.props.phoneConfirmation.fetched #=> boolean
  * this.props.phoneConfirmation.pending #=> boolean
  * this.props.phoneConfirmation.error   #=> null or something returned from action
  *
  * @method patchClientPhoneConfirmation
  *
  * @param  params  {patchClientPhoneConfirmation}  src/api/request/patchClientPhoneConfirmation.js
  *
  * @return {patchClientPhoneConfirmation} src/common/api/response/patchClientPhoneConfirmation.js
  */
function patchClientPhoneConfirmation(params) {
  return function (_ref59) {
    var httpPut = _ref59.httpPut;
    return {
      type: 'PATCH_CLIENT_PHONE_CONFIRMATION',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/phone-confirmation', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling patchClientPhoneConfirmation(params)
  */
function patchClientPhoneConfirmationReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_PHONE_CONFIRMATION_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * PUT /client/profile
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     profile: ['api', 'patch', 'client', 'profile', 'query']
  *   },
  *   actions: {
  *     patchClientProfile: ['api', 'patchClientProfile']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.profile.data    #=> Immutable.Map
  * this.props.profile.fetched #=> boolean
  * this.props.profile.pending #=> boolean
  * this.props.profile.error   #=> null or something returned from action
  *
  * @method patchClientProfile
  *
  * @param  params  {patchClientProfile}  src/api/request/patchClientProfile.js
  *
  */
function patchClientProfile(params) {
  return function (_ref60) {
    var httpPut = _ref60.httpPut;
    return {
      type: 'PATCH_CLIENT_PROFILE',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/profile', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling patchClientProfile(params)
  */
function patchClientProfileReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_PROFILE_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
} /**
  * PUT /client/settings
  *
  * Load response by connectState:
  * @connectState({
  *   state: {
  *     settings: ['api', 'patch', 'client', 'settings', 'query']
  *   },
  *   actions: {
  *     patchClientSettings: ['api', 'patchClientSettings']
  *   }
  * })
  *
  * In component you can get to query result by:
  * this.props.settings.data    #=> Immutable.Map
  * this.props.settings.fetched #=> boolean
  * this.props.settings.pending #=> boolean
  * this.props.settings.error   #=> null or something returned from action
  *
  * @method patchClientSettings
  *
  * @param  params  {patchClientSettings}  src/api/request/patchClientSettings.js
  *
  * @return {patchClientSettings} src/common/api/response/patchClientSettings.js
  */
function patchClientSettings(params) {
  return function (_ref61) {
    var httpPut = _ref61.httpPut;
    return {
      type: 'PATCH_CLIENT_SETTINGS',
      meta: {
        params: params
      },
      payload: {
        promise: httpPut('/client/settings', params)
      }
    };
  };
} /**
  * Reset state to its original state before calling patchClientSettings(params)
  */
function patchClientSettingsReset(params) {
  var hard = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
  return {
    type: 'PATCH_CLIENT_SETTINGS_RESET',
    meta: {
      params: params
    },
    hardReset: hard
  };
}